((window.NONO_ART = (function () {
  var N = "#103948",
    S =
      'stroke="#103948" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"',
    T = 'stroke="#103948" stroke-width="3" stroke-linecap="round" fill="none"';
  function pts(a) {
    return a
      .map(function (p) {
        return p[0].toFixed(1) + "," + p[1].toFixed(1);
      })
      .join(" ");
  }
  function spikyLeaf(cx, cy, a, b, rot, n, fill) {
    for (var p = [], r = (rot * Math.PI) / 180, i = 0; i < 2 * n; i++) {
      var t = (i / (2 * n)) * 2 * Math.PI,
        k = i % 2 ? 0.78 : 1.06,
        x = Math.cos(t) * a * k,
        y = Math.sin(t) * b * k;
      p.push([
        cx + x * Math.cos(r) - y * Math.sin(r),
        cy + x * Math.sin(r) + y * Math.cos(r),
      ]);
    }
    return '<polygon points="' + pts(p) + '" fill="' + fill + '" ' + S + "/>";
  }
  function star(cx, cy, r1, r2, n, fill) {
    for (var p = [], i = 0; i < 2 * n; i++) {
      var t = (i / (2 * n)) * 2 * Math.PI,
        r = i % 2 ? r2 : r1;
      p.push([cx + Math.cos(t) * r, cy + Math.sin(t) * r]);
    }
    return '<polygon points="' + pts(p) + '" fill="' + fill + '" ' + S + "/>";
  }
  function petals(cx, cy, n, len, w, fill) {
    for (var s = "", i = 0; i < n; i++)
      s +=
        '<ellipse cx="' +
        cx +
        '" cy="' +
        (cy - len) +
        '" rx="' +
        w +
        '" ry="' +
        len * 0.62 +
        '" transform="rotate(' +
        (i * 360) / n +
        " " +
        cx +
        " " +
        cy +
        ')" fill="' +
        fill +
        '" stroke="#103948" stroke-width="3"/>';
    return s;
  }
  var acorn =
      '<path d="M30 46h40c0 26-8 40-20 44-12-4-20-18-20-44z" fill="#E3A23B" ' +
      S +
      '/><path d="M24 48c0-14 12-22 26-22s26 8 26 22z" fill="#8a6a3d" ' +
      S +
      '/><path d="M50 26V12" fill="none" ' +
      S +
      "/>",
    groups = [
      ["minibeasts", "Minibeasts"],
      ["snails", "Snails and slugs"],
      ["birds", "Birds"],
      ["trees", "Trees and leaves"],
      ["amphibians", "Frogs, toads and newts"],
      ["mammals", "Mammals"],
      ["fungi", "Fungi and flowers"],
    ],
    items = {
      ladybird: {
        g: "minibeasts",
        name: "7-spot ladybird",
        short: "Ladybird",
        find: "Count its spots. Seven means a 7-spot.",
        s: 0.8,
        zone: "ground",
        svg:
          '<path d="M42 22 34 12M58 22l8-10" ' +
          T +
          '/><circle cx="50" cy="30" r="12" fill="' +
          N +
          '"/><ellipse cx="50" cy="60" rx="30" ry="27" fill="#C9543A" ' +
          S +
          '/><path d="M50 34v53" ' +
          S +
          '/><circle cx="37" cy="50" r="5" fill="' +
          N +
          '"/><circle cx="63" cy="50" r="5" fill="' +
          N +
          '"/><circle cx="36" cy="70" r="5" fill="' +
          N +
          '"/><circle cx="64" cy="70" r="5" fill="' +
          N +
          '"/><circle cx="50" cy="40" r="4.5" fill="' +
          N +
          '"/><circle cx="44" cy="62" r="4" fill="' +
          N +
          '"/><circle cx="56" cy="62" r="4" fill="' +
          N +
          '"/>',
      },
      woodlouse: {
        g: "minibeasts",
        name: "Woodlouse",
        short: "Woodlouse",
        find: "Lift a log gently, look, then put it back.",
        s: 0.8,
        zone: "ground",
        svg:
          '<path d="M24 66l-4 9M36 66l-2 9M48 66v9M60 66l2 9M72 66l4 9M16 58 4 48M18 62 5 61" ' +
          T +
          '/><path d="M14 66c0-18 16-32 38-32s34 14 34 32z" fill="#A7B0B6" ' +
          S +
          '/><path d="M30 40v26M42 35v31M54 34v32M66 37v29M77 45v21" ' +
          T +
          "/>",
      },
      worm: {
        g: "minibeasts",
        name: "Earthworm",
        short: "Worm",
        find: "Look on the grass after rain. Keep it damp and put it back.",
        s: 0.8,
        zone: "ground",
        svg:
          '<path d="M12 70c14-22 26 10 40-10s26-16 38 2" fill="none" stroke="' +
          N +
          '" stroke-width="17" stroke-linecap="round"/><path d="M12 70c14-22 26 10 40-10s26-16 38 2" fill="none" stroke="#D99A8A" stroke-width="10" stroke-linecap="round"/><path d="M62 47l3 9" stroke="#B9776A" stroke-width="4" stroke-linecap="round"/>',
      },
      bumblebee: {
        g: "minibeasts",
        name: "Buff-tailed bumblebee",
        short: "Bumblebee",
        find: "Look for a white tail on flowers. Watch, don\u2019t touch.",
        s: 0.8,
        zone: "sky",
        svg:
          '<ellipse cx="44" cy="32" rx="10" ry="14" fill="#fff" ' +
          S +
          '/><ellipse cx="58" cy="30" rx="10" ry="14" fill="#fff" ' +
          S +
          '/><ellipse cx="52" cy="58" rx="28" ry="20" fill="#E3A23B"/><path d="M46 39v38M60 39v38" stroke="' +
          N +
          '" stroke-width="7"/><path d="M70 43c8 3 10 9 10 15s-2 12-10 15z" fill="#fff"/><ellipse cx="52" cy="58" rx="28" ry="20" fill="none" ' +
          S +
          '/><circle cx="24" cy="56" r="9" fill="' +
          N +
          '"/>',
      },
      butterfly: {
        g: "minibeasts",
        name: "Small tortoiseshell butterfly",
        short: "Butterfly",
        find: "Orange wings on sunny flowers. Watch it land.",
        s: 0.85,
        zone: "sky",
        svg:
          '<path d="M50 48C40 18 12 12 10 30s16 26 40 18zM50 48C60 18 88 12 90 30s-16 26-40 18z" fill="#E07A3E" ' +
          S +
          '/><path d="M50 52C36 54 20 66 28 80s20-6 22-28zM50 52c14 2 30 14 22 28s-20-6-22-28z" fill="#E07A3E" ' +
          S +
          '/><circle cx="28" cy="28" r="4" fill="' +
          N +
          '"/><circle cx="72" cy="28" r="4" fill="' +
          N +
          '"/><circle cx="38" cy="38" r="3" fill="' +
          N +
          '"/><circle cx="62" cy="38" r="3" fill="' +
          N +
          '"/><circle cx="16" cy="34" r="2.5" fill="#5B8DB8"/><circle cx="84" cy="34" r="2.5" fill="#5B8DB8"/><path d="M50 30v48" stroke="' +
          N +
          '" stroke-width="6" stroke-linecap="round"/><path d="M50 30l-8-14M50 30l8-14" ' +
          T +
          "/>",
      },
      spider: {
        g: "minibeasts",
        name: "Garden spider",
        short: "Spider",
        find: "Look for a white cross on its back. Leave the web be.",
        s: 0.8,
        zone: "any",
        svg:
          '<path d="M50 44 22 26l-8 10M50 44 18 44l-6 12M50 48 22 62l-4 16M50 50 30 76l2 14M50 44 78 26l8 10M50 44l32 0 6 12M50 48l28 14 4 16M50 50l20 26-2 14" ' +
          T +
          '/><circle cx="50" cy="38" r="9" fill="#8a6a3d" ' +
          S +
          '/><ellipse cx="50" cy="62" rx="18" ry="20" fill="#8a6a3d" ' +
          S +
          '/><path d="M50 50v24M41 60h18" stroke="#fff" stroke-width="4" stroke-linecap="round"/>',
      },
      ant: {
        g: "minibeasts",
        name: "Black garden ant",
        short: "Ant",
        find: "Follow an ant trail and see where it goes.",
        s: 0.7,
        zone: "ground",
        svg:
          '<path d="M48 58 36 76M48 58v20M48 58l12 18M48 58 36 42M48 58l12-16M24 52l-8-12M30 50l2-14" ' +
          T +
          '/><circle cx="27" cy="58" r="9" fill="' +
          N +
          '"/><circle cx="47" cy="58" r="8" fill="' +
          N +
          '"/><ellipse cx="70" cy="60" rx="15" ry="12" fill="' +
          N +
          '"/><circle cx="24" cy="55" r="2" fill="#fff"/>',
      },
      snail: {
        g: "snails",
        name: "Garden snail",
        short: "Snail",
        find: "Under pots and stones after rain. Let it be.",
        s: 0.9,
        zone: "ground",
        svg:
          '<path d="M10 80h70c8 0 12-6 12-12" fill="none" ' +
          S +
          '/><path d="M12 80c0-9 5-14 12-14h44" fill="#DDC9A3" ' +
          S +
          '/><circle cx="50" cy="50" r="24" fill="#B9874F" ' +
          S +
          '/><path d="M50 50m-12 0a12 12 0 1 0 12-12" fill="none" ' +
          S +
          '/><path d="M84 66V48M93 67V51" fill="none" ' +
          S +
          "/>",
      },
      slug: {
        g: "snails",
        name: "Garden slug",
        short: "Slug",
        find: "Out on damp evenings. Look for its silvery trail.",
        s: 0.9,
        zone: "ground",
        svg:
          '<path d="M4 80h46" stroke="#C9D8E2" stroke-width="5" stroke-linecap="round"/><path d="M80 60l2-16M86 64l8-12" fill="none" ' +
          S +
          '/><circle cx="82" cy="43" r="3" fill="' +
          N +
          '"/><circle cx="95" cy="51" r="3" fill="' +
          N +
          '"/><path d="M10 76c0-12 14-20 34-20h22c14 0 22 8 22 20z" fill="#6B5A48" ' +
          S +
          '/><path d="M56 57c10 0 18 6 20 14" ' +
          T +
          '/><circle cx="70" cy="66" r="2.5" fill="#DDC9A3"/>',
      },
      robin: {
        g: "birds",
        name: "Robin",
        short: "Robin",
        find: "Red breast. Often sings, even in winter.",
        s: 0.9,
        zone: "tree",
        svg:
          '<path d="M45 76l-3 14M56 76l2 14" fill="none" ' +
          S +
          '/><path d="M24 50 6 40l4 20z" fill="#8a6a3d" ' +
          S +
          '/><ellipse cx="48" cy="54" rx="28" ry="24" fill="#8a6a3d" ' +
          S +
          '/><path d="M50 40c12-4 24 4 24 18 0 10-8 18-18 18-6 0-8-8-8-18z" fill="#D9643A" ' +
          S +
          '/><path d="M74 44l12 4-12 4z" fill="#E3A23B" ' +
          S +
          '/><circle cx="64" cy="40" r="3.2" fill="' +
          N +
          '"/>',
      },
      blackbird: {
        g: "birds",
        name: "Blackbird",
        short: "Blackbird",
        find: "Males are black with an orange beak. Females are brown.",
        s: 0.95,
        zone: "ground",
        svg:
          '<path d="M45 76l-3 14M56 76l2 14" fill="none" ' +
          S +
          '/><path d="M26 50 4 42l6 20z" fill="#24323A" ' +
          S +
          '/><ellipse cx="48" cy="56" rx="28" ry="21" fill="#24323A" ' +
          S +
          '/><circle cx="68" cy="38" r="13" fill="#24323A" ' +
          S +
          '/><path d="M79 36l12 3-12 4z" fill="#E3A23B" stroke="#E3A23B" stroke-width="2" stroke-linejoin="round"/><circle cx="71" cy="35" r="4" fill="none" stroke="#E3A23B" stroke-width="2.5"/><circle cx="71" cy="35" r="1.6" fill="#fff"/>',
      },
      bluetit: {
        g: "birds",
        name: "Blue tit",
        short: "Blue tit",
        find: "Small, blue and yellow. Watch the bird feeders.",
        s: 0.75,
        zone: "tree",
        svg:
          '<path d="M46 78l-2 12M56 78l2 12" fill="none" ' +
          S +
          '/><path d="M28 62 8 68l20 8z" fill="#5B8DB8" ' +
          S +
          '/><ellipse cx="50" cy="60" rx="24" ry="21" fill="#EBC944" ' +
          S +
          '/><path d="M28 60c0-16 10-26 24-26 6 0 10 2 13 5L40 74c-8-2-12-6-12-14z" fill="#5B8DB8" ' +
          S +
          '/><circle cx="62" cy="40" r="15" fill="#fff" ' +
          S +
          '/><path d="M48 34c4-8 18-10 26-2" fill="#5B8DB8" ' +
          S +
          '/><path d="M54 41h16" stroke="' +
          N +
          '" stroke-width="3.5" stroke-linecap="round"/><circle cx="66" cy="41" r="2.6" fill="' +
          N +
          '"/><path d="M76 42l8 2-8 3z" fill="' +
          N +
          '"/>',
      },
      magpie: {
        g: "birds",
        name: "Magpie",
        short: "Magpie",
        find: "Black and white, with a long tail.",
        s: 1,
        zone: "ground",
        svg:
          '<path d="M44 66l-2 20M52 66l2 20" fill="none" ' +
          S +
          '/><path d="M26 52 2 70l6 6 26-14z" fill="#24323A" ' +
          S +
          '/><ellipse cx="46" cy="52" rx="22" ry="16" fill="#24323A" ' +
          S +
          '/><path d="M36 58c6 10 20 10 26 0z" fill="#fff" ' +
          S +
          '/><ellipse cx="44" cy="46" rx="10" ry="4.5" fill="#fff"/><circle cx="68" cy="38" r="10" fill="#24323A" ' +
          S +
          '/><path d="M77 37l11 2-11 4z" fill="#24323A" ' +
          S +
          '/><circle cx="70" cy="36" r="2" fill="#fff"/>',
      },
      woodpigeon: {
        g: "birds",
        name: "Wood pigeon",
        short: "Wood pigeon",
        find: "Big grey pigeon with a white patch on its neck.",
        s: 1,
        zone: "tree",
        svg:
          '<path d="M44 78l-2 12M54 78l2 12" fill="none" ' +
          S +
          '/><path d="M20 52 2 48l4 16z" fill="#6E7B82" ' +
          S +
          '/><ellipse cx="46" cy="58" rx="30" ry="22" fill="#A7B0B6" ' +
          S +
          '/><path d="M58 46c12 4 16 16 10 26-8 6-16 2-18-6z" fill="#C9A3A8" ' +
          S +
          '/><circle cx="70" cy="34" r="11" fill="#A7B0B6" ' +
          S +
          '/><ellipse cx="64" cy="47" rx="6" ry="3" fill="#fff"/><path d="M80 33l9 3-9 3z" fill="#E3A23B" ' +
          S +
          '/><circle cx="72" cy="31" r="2.6" fill="' +
          N +
          '"/>',
      },
      sparrow: {
        g: "birds",
        name: "House sparrow",
        short: "Sparrow",
        find: "Small and brown. Listen for chirps in a hedge.",
        s: 0.8,
        zone: "tree",
        svg:
          '<path d="M45 78l-2 12M55 78l2 12" fill="none" ' +
          S +
          '/><path d="M26 56 8 50l6 18z" fill="#7A5A3A" ' +
          S +
          '/><ellipse cx="48" cy="60" rx="26" ry="20" fill="#B48A5E" ' +
          S +
          '/><path d="M30 56c6-6 16-8 26-2M32 64c8-4 16-4 22 0" ' +
          T +
          '/><circle cx="66" cy="40" r="13" fill="#B48A5E" ' +
          S +
          '/><path d="M55 34c4-6 14-8 22-2" fill="#A7B0B6" ' +
          S +
          '/><path d="M70 50c-3 4-3 8 1 12 4-2 6-6 6-10z" fill="' +
          N +
          '"/><path d="M78 40l9 2-9 4z" fill="' +
          N +
          '"/><circle cx="68" cy="39" r="2.6" fill="' +
          N +
          '"/>',
      },
      oak: {
        g: "trees",
        name: "Oak",
        short: "Oak",
        find: "Find an acorn in its little cup in autumn.",
        s: 0.95,
        zone: "any",
        svg:
          '<path d="M44 92V62" ' +
          S +
          '/><path d="M44 64c-14-2-20-10-16-16-8-2-10-12-2-16-4-8 4-16 12-12 2-8 12-8 14 0 8-4 16 4 12 12 8 4 6 14-2 16 4 6-2 14-16 16z" fill="#6F8F55" ' +
          S +
          '/><path d="M44 62V24" ' +
          T +
          '/><g transform="translate(60 56) scale(.44)">' +
          acorn +
          "</g>",
      },
      sycamore: {
        g: "trees",
        name: "Sycamore",
        short: "Sycamore",
        find: "Drop a seed and watch it spin like a helicopter.",
        s: 0.9,
        zone: "any",
        svg:
          '<path d="M46 70C36 50 18 32 8 22c16 0 34 12 40 38zM54 70C64 50 82 32 92 22c-16 0-34 12-40 38z" fill="#DDC9A3" ' +
          S +
          '/><path d="M44 66 22 34M56 66l22-32" stroke="#B49A70" stroke-width="2.5" stroke-linecap="round"/><circle cx="44" cy="72" r="9" fill="#8a6a3d" ' +
          S +
          '/><circle cx="56" cy="72" r="9" fill="#8a6a3d" ' +
          S +
          "/>",
      },
      conker: {
        g: "trees",
        name: "Horse chestnut (conker)",
        short: "Conker",
        find: "Shiny conkers in spiky cases in autumn.",
        s: 0.9,
        zone: "ground",
        svg:
          '<path d="M16 54l-6-6M24 40l-4-8M38 30l-1-9M54 28l2-9M68 34l5-8M80 46l7-5" ' +
          S +
          '/><path d="M12 60a38 34 0 0 1 76 0z" fill="#8FAF5E" ' +
          S +
          '/><circle cx="50" cy="66" r="22" fill="#7A3B22" ' +
          S +
          '/><path d="M38 58q6-8 14-8" stroke="#fff" stroke-width="4" stroke-linecap="round" fill="none"/><ellipse cx="54" cy="80" rx="10" ry="5" fill="#DDC9A3"/>',
      },
      birch: {
        g: "trees",
        name: "Silver birch",
        short: "Silver birch",
        find: "White, papery bark. Look, but don\u2019t peel it.",
        s: 1.4,
        zone: "tree",
        svg:
          '<ellipse cx="50" cy="32" rx="28" ry="26" fill="#B8C98E" ' +
          S +
          '/><path d="M44 46h12v46H44z" fill="#fff" ' +
          S +
          '/><path d="M44 56h6M50 66h6M44 76h5M51 84h5" stroke="' +
          N +
          '" stroke-width="3.5" stroke-linecap="round"/><path d="M34 24l2 6M52 16l1 6M64 30l2 6M40 40l2 5" ' +
          T +
          "/>",
      },
      holly: {
        g: "trees",
        name: "Holly",
        short: "Holly",
        find: "Prickly leaves. The berries aren\u2019t for eating.",
        s: 0.9,
        zone: "any",
        svg:
          spikyLeaf(34, 54, 28, 13, -30, 6, "#4F6B3A") +
          spikyLeaf(66, 54, 28, 13, 30, 6, "#4F6B3A") +
          '<circle cx="44" cy="30" r="8" fill="#C9543A" ' +
          S +
          '/><circle cx="57" cy="28" r="8" fill="#C9543A" ' +
          S +
          '/><circle cx="50" cy="40" r="8" fill="#C9543A" ' +
          S +
          "/>",
      },
      frog: {
        g: "amphibians",
        name: "Common frog",
        short: "Frog",
        find: "Smooth skin and long legs. Look near ponds with an adult.",
        s: 0.95,
        zone: "pond",
        svg:
          '<ellipse cx="50" cy="62" rx="34" ry="22" fill="#8C9A5B" ' +
          S +
          '/><circle cx="34" cy="40" r="11" fill="#8C9A5B" ' +
          S +
          '/><circle cx="66" cy="40" r="11" fill="#8C9A5B" ' +
          S +
          '/><circle cx="34" cy="40" r="4" fill="' +
          N +
          '"/><circle cx="66" cy="40" r="4" fill="' +
          N +
          '"/><path d="M22 50l10 4M78 50l-10 4" stroke="#5E5A3A" stroke-width="4" stroke-linecap="round"/><path d="M38 64q12 9 24 0" fill="none" ' +
          S +
          '/><path d="M14 84h18M68 84h18" fill="none" ' +
          S +
          "/>",
      },
      toad: {
        g: "amphibians",
        name: "Common toad",
        short: "Toad",
        find: "Bumpy skin. It walks more than it hops. Watch, don\u2019t pick up.",
        s: 0.95,
        zone: "ground",
        svg:
          '<ellipse cx="50" cy="64" rx="38" ry="22" fill="#9A7B55" ' +
          S +
          '/><circle cx="34" cy="46" r="10" fill="#9A7B55" ' +
          S +
          '/><circle cx="66" cy="46" r="10" fill="#9A7B55" ' +
          S +
          '/><circle cx="34" cy="46" r="5" fill="#E3A23B"/><circle cx="66" cy="46" r="5" fill="#E3A23B"/><path d="M30 46h8M62 46h8" stroke="' +
          N +
          '" stroke-width="3" stroke-linecap="round"/><circle cx="28" cy="66" r="3" fill="#6B5238"/><circle cx="44" cy="74" r="3" fill="#6B5238"/><circle cx="62" cy="72" r="3" fill="#6B5238"/><circle cx="74" cy="62" r="3" fill="#6B5238"/><path d="M40 62q10 5 20 0" ' +
          T +
          "/>",
      },
      newt: {
        g: "amphibians",
        name: "Smooth newt",
        short: "Newt",
        find: "In ponds in spring. Watch from the edge with an adult.",
        s: 0.95,
        zone: "pond",
        svg:
          '<path d="M28 66l-6 12M40 66l-2 12M64 64l4 12M74 62l6 10" ' +
          S +
          '/><path d="M6 58c12-2 26-12 46-12 14 0 22 4 30 4 6 0 10 4 12 8-2 4-8 6-14 6-10 0-22 6-36 6-14 0-26-6-38-12z" fill="#8C8461" ' +
          S +
          '/><path d="M30 66c14 2 30 0 44-6" stroke="#E07A3E" stroke-width="5" stroke-linecap="round" fill="none"/><circle cx="82" cy="54" r="2.8" fill="' +
          N +
          '"/>',
      },
      hedgehog: {
        g: "mammals",
        name: "Hedgehog",
        short: "Hedgehog",
        find: "Out at dusk. Watch quietly, don\u2019t pick up.",
        s: 1.1,
        zone: "ground",
        svg:
          '<path d="M30 76v8M60 76v8" fill="none" ' +
          S +
          '/><path d="M10 78 14 60l7 4 2-17 8 7 4-17 8 11 6-15 6 13 8-11 2 15 8-5-1 15 6 3H10z" fill="#8a6a3d" ' +
          S +
          '/><path d="M66 78c0-14 8-22 16-22s12 8 14 18l-2 4z" fill="#DDC9A3" ' +
          S +
          '/><circle cx="95" cy="73" r="3" fill="' +
          N +
          '"/><circle cx="82" cy="65" r="3" fill="' +
          N +
          '"/>',
      },
      squirrel: {
        g: "mammals",
        name: "Grey squirrel",
        short: "Squirrel",
        find: "Bushy tail. Busy in trees and parks all year.",
        s: 1,
        zone: "tree",
        svg:
          '<path d="M34 84C8 80 4 44 22 30c10-8 26-2 22 12-4 10-16 8-14 24 2 8 6 12 12 14z" fill="#A7B0B6" ' +
          S +
          '/><ellipse cx="56" cy="66" rx="18" ry="20" fill="#A7B0B6" ' +
          S +
          '/><path d="M58 52c6 4 8 14 4 26" fill="none" stroke="#FFF4EC" stroke-width="6" stroke-linecap="round"/><circle cx="66" cy="40" r="13" fill="#A7B0B6" ' +
          S +
          '/><path d="M58 30l-2-10 8 6" fill="#A7B0B6" ' +
          S +
          '/><circle cx="70" cy="38" r="2.8" fill="' +
          N +
          '"/><path d="M48 86h20" ' +
          S +
          "/>",
      },
      fox: {
        g: "mammals",
        name: "Red fox",
        short: "Fox",
        find: "Often out at dusk, even in towns. Keep your distance.",
        s: 1.2,
        zone: "ground",
        svg:
          '<path d="M20 64C4 66 0 82 10 88c10 2 16-8 18-16z" fill="#D9643A" ' +
          S +
          '/><circle cx="9" cy="85" r="5" fill="#fff"/><path d="M30 74v14M62 74v14" stroke="' +
          N +
          '" stroke-width="5" stroke-linecap="round"/><path d="M20 72c0-14 14-22 32-22s24 8 24 22z" fill="#D9643A" ' +
          S +
          '/><path d="M62 52l6-24 8 14 10-12 2 22 8 8-20 10z" fill="#D9643A" ' +
          S +
          '/><path d="M78 68l18-6-4 6z" fill="#fff" ' +
          S +
          '/><circle cx="96" cy="62" r="2.6" fill="' +
          N +
          '"/><circle cx="80" cy="54" r="2.6" fill="' +
          N +
          '"/>',
      },
      rabbit: {
        g: "mammals",
        name: "Rabbit",
        short: "Rabbit",
        find: "A white tail bobbing at the field edge, at dawn and dusk.",
        s: 1,
        zone: "ground",
        svg:
          '<ellipse cx="64" cy="22" rx="5" ry="16" fill="#A57F55" ' +
          S +
          ' transform="rotate(-12 64 22)"/><ellipse cx="76" cy="24" rx="5" ry="16" fill="#A57F55" ' +
          S +
          ' transform="rotate(14 76 24)"/><ellipse cx="46" cy="64" rx="28" ry="20" fill="#A57F55" ' +
          S +
          '/><circle cx="70" cy="48" r="13" fill="#A57F55" ' +
          S +
          '/><circle cx="20" cy="60" r="7" fill="#fff" ' +
          S +
          '/><circle cx="74" cy="45" r="2.6" fill="' +
          N +
          '"/><circle cx="82" cy="52" r="2" fill="' +
          N +
          '"/><path d="M40 84h22" ' +
          S +
          "/>",
      },
      daisy: {
        g: "fungi",
        name: "Daisy",
        short: "Daisy",
        find: "White petals, yellow middle. They close at night.",
        s: 0.7,
        zone: "ground",
        svg:
          '<path d="M50 52v42" ' +
          S +
          "/>" +
          petals(50, 38, 12, 18, 5, "#fff") +
          '<circle cx="50" cy="38" r="9" fill="#EBC944" ' +
          S +
          "/>",
      },
      dandelion: {
        g: "fungi",
        name: "Dandelion",
        short: "Dandelion",
        find: "A yellow flower, then a fluffy seed clock.",
        s: 0.8,
        zone: "ground",
        svg:
          '<path d="M50 56v36" ' +
          S +
          '/><path d="M50 90c-10-2-14-8-24-6 4-4 2-8 8-10-4-2-4-6 2-8 4 4 10 4 14 10z" fill="#6F8F55" ' +
          S +
          "/>" +
          star(50, 36, 24, 16, 16, "#EBC944") +
          '<circle cx="50" cy="36" r="7" fill="#E3A23B"/>',
      },
      flyagaric: {
        g: "fungi",
        name: "Fly agaric",
        short: "Fly agaric",
        find: "Red cap, white spots, often under birch in autumn. Never touch.",
        s: 0.85,
        zone: "ground",
        svg:
          '<path d="M40 56h20l4 30H36z" fill="#FFF4EC" ' +
          S +
          '/><path d="M12 58C12 30 30 16 50 16s38 14 38 42z" fill="#C9543A" ' +
          S +
          '/><circle cx="34" cy="40" r="5" fill="#FFF4EC"/><circle cx="56" cy="30" r="4" fill="#FFF4EC"/><circle cx="68" cy="46" r="5" fill="#FFF4EC"/><circle cx="46" cy="48" r="3.5" fill="#FFF4EC"/>',
      },
    },
    times = {
      morning: {
        label: "Morning",
        sky: "#F6E6D3",
        hill: "#DDE5D3",
        sun: [210, 130, "#E3A23B"],
      },
      afternoon: {
        label: "Afternoon",
        sky: "#E6EFF3",
        hill: "#DDE5D3",
        sun: [420, 72, "#E3A23B"],
      },
      evening: {
        label: "Evening",
        sky: "#E6D2DC",
        hill: "#CBD5C0",
        sun: [545, 200, "#E07A3E"],
      },
    };
  function tree(x, y, r, h) {
    return (
      '<rect x="' +
      (x - 10) +
      '" y="' +
      (y - 10) +
      '" width="20" height="' +
      h +
      '" fill="#8a6a3d" ' +
      S +
      '/><circle cx="' +
      (x - r * 0.55) +
      '" cy="' +
      (y - r * 0.25) +
      '" r="' +
      r * 0.7 +
      '" fill="#6F8F55" ' +
      S +
      '/><circle cx="' +
      (x + r * 0.55) +
      '" cy="' +
      (y - r * 0.2) +
      '" r="' +
      r * 0.7 +
      '" fill="#6F8F55" ' +
      S +
      '/><circle cx="' +
      x +
      '" cy="' +
      (y - r * 0.75) +
      '" r="' +
      r * 0.8 +
      '" fill="#6F8F55" ' +
      S +
      "/>"
    );
  }
  function tuft(x, y) {
    return (
      '<path d="M' +
      (x - 8) +
      " " +
      y +
      "l-4-14M" +
      x +
      " " +
      y +
      "v-18M" +
      (x + 8) +
      " " +
      y +
      'l4-14" fill="none" stroke="#4F6B3A" stroke-width="4" stroke-linecap="round"/>'
    );
  }
  function scene(t) {
    for (var c = times[t], sn = c.sun, hedge = "", i = 0; i < 9; i++)
      hedge +=
        '<circle cx="' +
        (250 + i * 40) +
        '" cy="372" r="30" fill="#4F6B3A" ' +
        S +
        "/>";
    return (
      '<rect width="800" height="600" fill="' +
      c.sky +
      '"/><g stroke="#103948" stroke-width="4" stroke-linecap="round"><path d="M' +
      sn[0] +
      " " +
      (sn[1] - 44) +
      "v12M" +
      sn[0] +
      " " +
      (sn[1] + 32) +
      "v12M" +
      (sn[0] - 44) +
      " " +
      sn[1] +
      "h12M" +
      (sn[0] + 32) +
      " " +
      sn[1] +
      'h12"/></g><circle cx="' +
      sn[0] +
      '" cy="' +
      sn[1] +
      '" r="24" fill="' +
      sn[2] +
      '" ' +
      S +
      '/><path d="M0 320C140 270 260 300 380 286s290-40 420 6V600H0z" fill="' +
      c.hill +
      '"/>' +
      hedge +
      tree(100, 250, 78, 200) +
      tree(720, 240, 72, 200) +
      '<path d="M0 400c160-24 320-16 460-10s240-6 340-14V600H0z" fill="#A9B98F" stroke="#103948" stroke-width="4"/><path d="M300 600c30-60 110-90 110-196h36c6 110-64 140-70 196z" fill="#E9DCC0"/><ellipse cx="625" cy="512" rx="150" ry="52" fill="#9FC3D6" stroke="#103948" stroke-width="4"/><path d="M570 506q34-8 68 0M650 528q30-6 60 0" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round"/><path d="M488 498V418M504 498V402M520 500V426" stroke="#4F6B3A" stroke-width="5" stroke-linecap="round"/><rect x="497" y="388" width="14" height="32" rx="7" fill="#8a6a3d" stroke="#103948" stroke-width="3"/><rect x="40" y="478" width="170" height="44" rx="22" fill="#8a6a3d" stroke="#103948" stroke-width="4"/><ellipse cx="190" cy="500" rx="16" ry="22" fill="#DDC9A3" stroke="#103948" stroke-width="4"/><path d="M190 492a6 8 0 1 0 1 0" fill="none" stroke="#8a6a3d" stroke-width="3"/>' +
      tuft(250, 470) +
      tuft(120, 560) +
      tuft(470, 560) +
      tuft(770, 470)
    );
  }
  return { items: items, groups: groups, times: times, scene: scene };
})()),
  (function (A) {
    var N = "#103948",
      S =
        'stroke="#103948" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"',
      T =
        'stroke="#103948" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" fill="none"';
    function spiral(cx, cy, rmax, turns, phase) {
      for (var d = "", n = Math.round(turns * 36), i = 0; i <= n; i++) {
        var t = (i / n) * turns * 2 * Math.PI,
          r = rmax * (1 - i / n) + 1.5,
          x = cx + r * Math.cos(t + phase),
          y = cy + r * Math.sin(t + phase);
        d += (i ? "L" : "M") + x.toFixed(1) + " " + y.toFixed(1);
      }
      return '<path d="' + d + '" ' + T + "/>";
    }
    function spikes(cx, cy, rx, ry, n) {
      for (var p = [], i = 0; i <= 2 * n; i++) {
        var a = Math.PI + (i / (2 * n)) * Math.PI,
          k = i % 2 ? 1.12 : 0.92;
        p.push(
          (cx + Math.cos(a) * rx * k).toFixed(1) +
            "," +
            (cy + Math.sin(a) * ry * k).toFixed(1),
        );
      }
      return (
        '<polygon points="' +
        p.join(" ") +
        " " +
        (cx + rx * 0.92) +
        "," +
        cy +
        '" fill="#8a6a3d" ' +
        S +
        "/>"
      );
    }
    var acorn =
        '<path d="M30 46h40c0 26-8 40-20 44-12-4-20-18-20-44z" fill="#E3A23B" ' +
        S +
        '/><path d="M24 48c0-14 12-22 26-22s26 8 26 22z" fill="#8a6a3d" ' +
        S +
        '/><path d="M50 26V14" fill="none" ' +
        S +
        "/>",
      it = A.items;
    ((it.snail.svg =
      '<path d="M80 46 74 26M88 46l6-19" ' +
      T +
      '/><circle cx="74" cy="25" r="4.5" fill="' +
      N +
      '"/><circle cx="94" cy="26" r="4.5" fill="' +
      N +
      '"/><path d="M6 86c0-6 6-10 14-10h50c6 0 8-6 8-14V54c0-8 4-12 9-12s9 4 9 12v24c0 6-4 10-10 10H10c-3 0-4-1-4-2z" fill="#DDC9A3" ' +
      S +
      '/><circle cx="88" cy="58" r="2.6" fill="' +
      N +
      '"/><circle cx="44" cy="52" r="27" fill="#C98A4B" ' +
      S +
      "/>" +
      spiral(44, 52, 20, 2.1, Math.PI * 0.9)),
      (it.slug.svg =
        '<path d="M4 92h44" stroke="#C9D8E2" stroke-width="5" stroke-linecap="round"/><path d="M82 56 76 35M90 56l6-19" ' +
        T +
        '/><circle cx="76" cy="34" r="4.5" fill="' +
        N +
        '"/><circle cx="96" cy="36" r="4.5" fill="' +
        N +
        '"/><path d="M8 82c0-14 14-22 32-22h26c8 0 12-4 16-8 4-3 10-2 12 4 2 8 2 18 2 26 0 4-2 6-6 6H12c-3 0-4-2-4-6z" fill="#9A7458" ' +
        S +
        '/><path d="M30 64c10-6 28-6 38 0" ' +
        T +
        '/><circle cx="56" cy="72" r="3" fill="#6B5238"/><circle cx="87" cy="64" r="2.6" fill="' +
        N +
        '"/>'),
      (it.hedgehog.svg =
        '<path d="M26 80v8M54 80v8" stroke="' +
        N +
        '" stroke-width="6" stroke-linecap="round"/>' +
        spikes(42, 80, 36, 40, 11) +
        '<path d="M60 80c0-14 8-24 16-24 8 0 14 10 20 22l-2 2H60z" fill="#E8D5B5" ' +
        S +
        '/><circle cx="95" cy="78" r="4" fill="' +
        N +
        '"/><circle cx="76" cy="66" r="3" fill="' +
        N +
        '"/>'),
      (it.bluetit.svg =
        '<path d="M44 80l-2 12M56 80l2 12" ' +
        S +
        '/><path d="M26 60 8 54l6 18z" fill="#5B8DB8" ' +
        S +
        '/><circle cx="48" cy="60" r="24" fill="#EBC944" ' +
        S +
        '/><path d="M26 56c2-10 10-16 18-14-4 12-2 24 6 36-14 0-26-8-24-22z" fill="#5B8DB8" ' +
        S +
        '/><circle cx="62" cy="36" r="16" fill="#fff" ' +
        S +
        '/><path d="M46.5 33a16 16 0 0 1 31 0z" fill="#5B8DB8" ' +
        S +
        '/><path d="M54 39h16" stroke="' +
        N +
        '" stroke-width="3" stroke-linecap="round"/><circle cx="66" cy="39" r="3" fill="' +
        N +
        '"/><path d="M78 37l8 3-8 3z" fill="' +
        N +
        '" ' +
        S +
        "/>"),
      (it.oak.svg =
        '<path d="M40 82v12" ' +
        S +
        '/><path d="M40 82c-10 0-12-8-8-12-10 0-12-10-4-14-10-2-10-12-2-14-6-6-2-14 6-12-2-8 4-14 8-14s10 6 8 14c8-2 12 6 6 12 8 2 8 12-2 14 8 4 6 14-4 14 4 4 2 12-8 12z" fill="#6F8F55" ' +
        S +
        '/><path d="M40 26v56M40 44l-8-4M40 44l8-4M40 60l-9-4M40 60l9-4" ' +
        T +
        '/><g transform="translate(58 54) scale(.42)">' +
        acorn +
        "</g>"),
      (it.fox.svg =
        '<path d="M34 68v18M44 70v16M60 70v16M68 66v20" stroke="' +
        N +
        '" stroke-width="5" stroke-linecap="round"/><path d="M26 56C10 50 2 62 4 74c2 8 10 10 16 6-4-6-2-14 8-16z" fill="#D9643A" ' +
        S +
        '/><path d="M5 76c2 6 9 8 15 4-5-1-9-4-10-8z" fill="#fff" stroke="' +
        N +
        '" stroke-width="3" stroke-linejoin="round"/><path d="M22 58c0-10 12-14 28-14h14c6 0 8 6 8 12 0 10-8 14-22 14H34c-8 0-12-4-12-12z" fill="#D9643A" ' +
        S +
        '/><path d="M62 50l6-28 10 14 10-14 4 26c4 4 6 8 6 10-8 4-20 4-30 0z" fill="#D9643A" ' +
        S +
        '/><path d="M76 58c8 2 14 2 20 0-4 6-14 8-22 4z" fill="#fff" stroke="' +
        N +
        '" stroke-width="3" stroke-linejoin="round"/><circle cx="96" cy="58" r="3.5" fill="' +
        N +
        '"/><circle cx="82" cy="46" r="3" fill="' +
        N +
        '"/>'),
      (it.ant.svg =
        '<path d="M38 62 28 78M44 64v16M50 62l10 16M20 50 14 36l-8 2M26 48l4-14 8-4" ' +
        T +
        '/><circle cx="24" cy="56" r="10" fill="' +
        N +
        '"/><ellipse cx="44" cy="58" rx="9" ry="7" fill="' +
        N +
        '"/><ellipse cx="70" cy="58" rx="17" ry="13" fill="' +
        N +
        '"/><circle cx="21" cy="53" r="2.4" fill="#fff"/>'),
      (it.squirrel.svg =
        '<path d="M34 86C8 82 4 46 22 32c10-8 26-2 22 12-4 10-16 8-14 24 2 8 6 12 12 14z" fill="#A7B0B6" ' +
        S +
        '/><ellipse cx="56" cy="66" rx="18" ry="20" fill="#A7B0B6" ' +
        S +
        '/><path d="M58 52c6 4 8 14 4 26" fill="none" stroke="#fff" stroke-width="6" stroke-linecap="round"/><ellipse cx="61" cy="26" rx="5.5" ry="9" transform="rotate(-12 61 26)" fill="#A7B0B6" ' +
        S +
        '/><circle cx="66" cy="40" r="13" fill="#A7B0B6" ' +
        S +
        '/><circle cx="71" cy="38" r="3" fill="' +
        N +
        '"/><circle cx="79" cy="44" r="2" fill="' +
        N +
        '"/><circle cx="70" cy="62" r="7" fill="#8a6a3d" ' +
        S +
        '/><path d="M46 88h22" ' +
        S +
        "/>"),
      (it.robin.svg = it.robin.svg.replace(
        '<circle cx="64" cy="40" r="3.2" fill="' + N + '"/>',
        '<circle cx="65" cy="39" r="3.6" fill="' +
          N +
          '"/><circle cx="66" cy="38" r="1.2" fill="#fff"/>',
      )),
      (it.ladybird.svg = it.ladybird.svg.replace(
        '<circle cx="50" cy="30" r="12" fill="' + N + '"/>',
        '<circle cx="50" cy="30" r="12" fill="' +
          N +
          '"/><circle cx="45" cy="27" r="2.4" fill="#fff"/><circle cx="55" cy="27" r="2.4" fill="#fff"/>',
      )),
      (it.bumblebee.svg += '<circle cx="21" cy="53" r="2.4" fill="#fff"/>'),
      (it.birch.svg = it.birch.svg.replace(
        '<path d="M34 24l2 6M52 16l1 6M64 30l2 6M40 40l2 5" stroke="#103948" stroke-width="3" stroke-linecap="round" fill="none"/>',
        "",
      )),
      (it.woodpigeon.svg = it.woodpigeon.svg.replace(
        '<path d="M58 46c12 4 16 16 10 26-8 6-16 2-18-6z" fill="#C9A3A8" ' +
          S +
          "/>",
        '<path d="M58 44c10 2 16 12 12 24-6 4-12 0-14-8z" fill="#C9A3A8"/>',
      )));
  })(window.NONO_ART),
  (function (A) {
    var S =
      'stroke="#103948" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"';
    ((A.times.morning.sky = "#F7EADB"),
      (A.times.afternoon.sky = "#E8F0F3"),
      (A.times.evening.sky = "#EBDCE3"),
      (A.times.evening.hill = "#D3DCC8"),
      (A.times.morning.sun = [200, 120, "#E3A23B"]),
      (A.times.afternoon.sun = [400, 78, "#E3A23B"]),
      (A.times.evening.sun = [560, 190, "#E07A3E"]),
      (A.groups = [
        ["minibeasts", "Minibeasts", "Minibeasts", "ladybird"],
        ["snails", "Snails and slugs", "Snails", "snail"],
        ["birds", "Birds", "Birds", "robin"],
        ["trees", "Trees and leaves", "Trees", "oak"],
        ["amphibians", "Frogs, toads and newts", "Frogs", "frog"],
        ["mammals", "Mammals", "Mammals", "hedgehog"],
        ["fungi", "Fungi and flowers", "Flowers", "daisy"],
      ]));
    function tree(x, y, r, h) {
      return (
        '<rect x="' +
        (x - 10) +
        '" y="' +
        (y - 10) +
        '" width="20" height="' +
        h +
        '" rx="4" fill="#8a6a3d" ' +
        S +
        '/><circle cx="' +
        (x - r * 0.55) +
        '" cy="' +
        (y - r * 0.25) +
        '" r="' +
        r * 0.7 +
        '" fill="#7C9A60" ' +
        S +
        '/><circle cx="' +
        (x + r * 0.55) +
        '" cy="' +
        (y - r * 0.2) +
        '" r="' +
        r * 0.7 +
        '" fill="#7C9A60" ' +
        S +
        '/><circle cx="' +
        x +
        '" cy="' +
        (y - r * 0.75) +
        '" r="' +
        r * 0.8 +
        '" fill="#7C9A60" ' +
        S +
        "/>"
      );
    }
    function tuft(x, y) {
      return (
        '<path d="M' +
        (x - 7) +
        " " +
        y +
        "l-3-12M" +
        x +
        " " +
        y +
        "v-15M" +
        (x + 7) +
        " " +
        y +
        'l3-12" fill="none" stroke="#6F8F55" stroke-width="4" stroke-linecap="round"/>'
      );
    }
    A.scene = function (t) {
      for (var c = A.times[t], sn = c.sun, hedge = "", i = 0; i < 7; i++)
        hedge +=
          '<circle cx="' +
          (270 + i * 44) +
          '" cy="378" r="30" fill="#8FA874" ' +
          S +
          "/>";
      var cloud =
        t === "afternoon"
          ? '<path d="M560 140h80a20 20 0 0 0 0-40 28 28 0 0 0-52-8 22 22 0 0 0-28 48z" fill="#fff" ' +
            S +
            "/>"
          : "";
      return (
        '<rect width="800" height="600" fill="' +
        c.sky +
        '"/><g stroke="#103948" stroke-width="4" stroke-linecap="round"><path d="M' +
        sn[0] +
        " " +
        (sn[1] - 44) +
        "v12M" +
        sn[0] +
        " " +
        (sn[1] + 32) +
        "v12M" +
        (sn[0] - 44) +
        " " +
        sn[1] +
        "h12M" +
        (sn[0] + 32) +
        " " +
        sn[1] +
        'h12"/></g><circle cx="' +
        sn[0] +
        '" cy="' +
        sn[1] +
        '" r="24" fill="' +
        sn[2] +
        '" ' +
        S +
        "/>" +
        cloud +
        '<path d="M0 316C140 272 260 300 380 288s290-36 420 4V600H0z" fill="' +
        c.hill +
        '"/>' +
        hedge +
        tree(100, 250, 78, 200) +
        tree(720, 240, 72, 200) +
        '<path d="M0 402c160-22 320-14 460-8s240-6 340-12V600H0z" fill="#B3C39A" stroke="#103948" stroke-width="4"/><path d="M310 600c26-60 100-96 102-194h30c4 108-58 140-64 194z" fill="#EFE4CC"/><ellipse cx="628" cy="512" rx="146" ry="50" fill="#A9CCDD" stroke="#103948" stroke-width="4"/><path d="M574 506q30-7 60 0" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round"/><path d="M700 528a20 9 0 1 0 1 0" fill="#7C9A60" stroke="#103948" stroke-width="3"/><path d="M492 496v-60M506 498v-74" stroke="#6F8F55" stroke-width="5" stroke-linecap="round"/><rect x="499" y="410" width="14" height="30" rx="7" fill="#8a6a3d" stroke="#103948" stroke-width="3"/><rect x="40" y="480" width="164" height="42" rx="21" fill="#8a6a3d" stroke="#103948" stroke-width="4"/><ellipse cx="186" cy="501" rx="15" ry="21" fill="#DDC9A3" stroke="#103948" stroke-width="4"/><path d="M186 494a5 7 0 1 0 1 0" fill="none" stroke="#8a6a3d" stroke-width="3"/>' +
        tuft(250, 468) +
        tuft(470, 566) +
        tuft(770, 470)
      );
    };
  })(window.NONO_ART),
  (function (A) {
    var N = "#103948",
      S =
        'stroke="#103948" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"',
      T =
        'stroke="#103948" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" fill="none"',
      it = A.items;
    ((it.robin.svg =
      '<path d="M44 76l-3 14M56 76l2 14" ' +
      S +
      ' fill="none"/><path d="M24 54 6 46l6 20z" fill="#8a6a3d" ' +
      S +
      '/><ellipse cx="46" cy="60" rx="27" ry="21" fill="#8a6a3d" ' +
      S +
      '/><circle cx="66" cy="40" r="16" fill="#8a6a3d" ' +
      S +
      '/><path d="M62 27c10-2 19 6 19 15 0 8-5 12-8 18-3 9-9 15-17 17-4-10-4-22-1-32 1-9 2-15 7-18z" fill="#D9643A" ' +
      S +
      '/><path d="M81 37l11 4-11 4z" fill="#E3A23B" ' +
      S +
      '/><circle cx="70" cy="36" r="3.4" fill="' +
      N +
      '"/><circle cx="71" cy="35" r="1.1" fill="#fff"/>'),
      (it.ant.svg =
        '<path d="M44 60 34 76l-6 2M48 62l-2 18-5 3M52 60l10 16 6 2M40 58 26 70l-6 0M56 58l16 10 6-1M48 58v-2" ' +
        T +
        '/><path d="M76 46l6-14 8-4M80 48l12-8 6 2" ' +
        T +
        '/><ellipse cx="22" cy="56" rx="18" ry="14" fill="' +
        N +
        '"/><ellipse cx="48" cy="56" rx="10" ry="7" fill="' +
        N +
        '"/><circle cx="72" cy="52" r="11" fill="' +
        N +
        '"/><circle cx="76" cy="49" r="2.4" fill="#fff"/>'),
      (A.places = {
        woods: "Woods",
        garden: "Garden",
        park: "Park",
        pond: "Pond",
      }));
    function tree(x, y, r, h, f) {
      return (
        (f = f || "#7C9A60"),
        '<rect x="' +
          (x - 10) +
          '" y="' +
          (y - 10) +
          '" width="20" height="' +
          h +
          '" rx="4" fill="#8a6a3d" ' +
          S +
          '/><circle cx="' +
          (x - r * 0.55) +
          '" cy="' +
          (y - r * 0.25) +
          '" r="' +
          r * 0.7 +
          '" fill="' +
          f +
          '" ' +
          S +
          '/><circle cx="' +
          (x + r * 0.55) +
          '" cy="' +
          (y - r * 0.2) +
          '" r="' +
          r * 0.7 +
          '" fill="' +
          f +
          '" ' +
          S +
          '/><circle cx="' +
          x +
          '" cy="' +
          (y - r * 0.75) +
          '" r="' +
          r * 0.8 +
          '" fill="' +
          f +
          '" ' +
          S +
          "/>"
      );
    }
    function far(x, y, r) {
      return (
        '<rect x="' +
        (x - 6) +
        '" y="' +
        y +
        '" width="12" height="70" fill="#A89676"/><circle cx="' +
        x +
        '" cy="' +
        y +
        '" r="' +
        r +
        '" fill="#A7BA90"/>'
      );
    }
    function tuft(x, y) {
      return (
        '<path d="M' +
        (x - 7) +
        " " +
        y +
        "l-3-12M" +
        x +
        " " +
        y +
        "v-15M" +
        (x + 7) +
        " " +
        y +
        'l3-12" fill="none" stroke="#6F8F55" stroke-width="4" stroke-linecap="round"/>'
      );
    }
    function fern(x, y) {
      for (
        var s =
            '<path d="M' +
            x +
            " " +
            y +
            "q0-30 " +
            (x > 400 ? -14 : 14) +
            '-44" fill="none" stroke="#5E7F48" stroke-width="4" stroke-linecap="round"/>',
          i = 0;
        i < 4;
        i++
      ) {
        var yy = y - 8 - i * 9;
        s +=
          '<path d="M' +
          x +
          " " +
          yy +
          "l-14-6M" +
          x +
          " " +
          yy +
          'l14-6" stroke="#5E7F48" stroke-width="4" stroke-linecap="round"/>';
      }
      return s;
    }
    function sky(t) {
      var c = A.times[t],
        sn = c.sun;
      return (
        '<rect width="800" height="600" fill="' +
        c.sky +
        '"/><g stroke="#103948" stroke-width="4" stroke-linecap="round"><path d="M' +
        sn[0] +
        " " +
        (sn[1] - 44) +
        "v12M" +
        sn[0] +
        " " +
        (sn[1] + 32) +
        "v12M" +
        (sn[0] - 44) +
        " " +
        sn[1] +
        "h12M" +
        (sn[0] + 32) +
        " " +
        sn[1] +
        'h12"/></g><circle cx="' +
        sn[0] +
        '" cy="' +
        sn[1] +
        '" r="24" fill="' +
        sn[2] +
        '" ' +
        S +
        "/>" +
        (t === "afternoon"
          ? '<path d="M560 140h80a20 20 0 0 0 0-40 28 28 0 0 0-52-8 22 22 0 0 0-28 48z" fill="#fff" ' +
            S +
            "/>"
          : "")
      );
    }
    var log =
        '<rect x="40" y="480" width="164" height="42" rx="21" fill="#8a6a3d" ' +
        S +
        '/><ellipse cx="186" cy="501" rx="15" ry="21" fill="#DDC9A3" ' +
        S +
        '/><path d="M186 494a5 7 0 1 0 1 0" fill="none" stroke="#8a6a3d" stroke-width="3"/>',
      B = {};
    ((B.woods = function (t) {
      var c = A.times[t];
      return (
        sky(t) +
        '<path d="M0 330C160 300 300 316 420 306s270-26 380 0V600H0z" fill="' +
        c.hill +
        '"/>' +
        far(250, 300, 40) +
        far(380, 290, 46) +
        far(520, 296, 40) +
        far(620, 306, 34) +
        tree(100, 250, 78, 200, "#6F8F55") +
        tree(720, 240, 72, 200, "#6F8F55") +
        '<path d="M0 404c160-14 320-10 460-6s240-4 340-10V600H0z" fill="#A9B68A" stroke="#103948" stroke-width="4"/><path d="M330 600c20-60 70-110 66-198h26c10 96-30 140-36 198z" fill="#D9C9A6"/>' +
        log +
        '<g fill="#D08A4E"><ellipse cx="260" cy="560" rx="9" ry="5"/><ellipse cx="520" cy="450" rx="9" ry="5" transform="rotate(30 520 450)"/><ellipse cx="640" cy="560" rx="9" ry="5" transform="rotate(-20 640 560)"/><ellipse cx="230" cy="440" rx="8" ry="5"/></g>' +
        fern(560, 520) +
        fern(740, 500) +
        fern(250, 470)
      );
    }),
      (B.garden = function (t) {
        for (var c = A.times[t], f = "", i = 0; i < 16; i++)
          f +=
            '<path d="M' +
            (i * 50 + 4) +
            ' 312l21-14 21 14v108h-42z" fill="#D7B48B" stroke="#103948" stroke-width="3" stroke-linejoin="round"/>';
        return (
          sky(t) +
          f +
          '<rect x="0" y="340" width="800" height="12" fill="#B8936A"/><rect x="0" y="390" width="800" height="12" fill="#B8936A"/>' +
          tree(110, 250, 74, 190, "#7C9A60") +
          tree(710, 240, 70, 190, "#7C9A60") +
          '<g fill="#C9543A"><circle cx="690" cy="210" r="7"/><circle cx="740" cy="236" r="7"/><circle cx="700" cy="262" r="7"/></g><path d="M0 420h800V600H0z" fill="#B3C39A" stroke="#103948" stroke-width="4"/><path d="M0 420h800v28H0z" fill="#8A6A4E"/><g stroke="#103948" stroke-width="3"><circle cx="210" cy="430" r="8" fill="#E8B6C2"/><circle cx="330" cy="428" r="8" fill="#EBC944"/><circle cx="470" cy="430" r="8" fill="#E8B6C2"/><circle cx="590" cy="428" r="8" fill="#fff"/></g><g fill="#DCD2C0" stroke="#103948" stroke-width="3"><ellipse cx="400" cy="584" rx="34" ry="12"/><ellipse cx="430" cy="536" rx="30" ry="11"/><ellipse cx="400" cy="494" rx="26" ry="10"/></g><path d="M650 530h56l-8 44h-40z" fill="#C9734A" ' +
          S +
          '/><path d="M664 530c-6-16 0-28 14-32 12 6 14 18 8 32" fill="#6F8F55" ' +
          S +
          "/>" +
          tuft(120, 520) +
          tuft(560, 560)
        );
      }),
      (B.park = function (t) {
        for (var c = A.times[t], hedge = "", i = 0; i < 7; i++)
          hedge +=
            '<circle cx="' +
            (270 + i * 44) +
            '" cy="378" r="30" fill="#8FA874" ' +
            S +
            "/>";
        return (
          sky(t) +
          '<path d="M0 316C140 272 260 300 380 288s290-36 420 4V600H0z" fill="' +
          c.hill +
          '"/>' +
          hedge +
          tree(100, 250, 78, 200) +
          tree(720, 240, 72, 200) +
          '<path d="M0 402c160-22 320-14 460-8s240-6 340-12V600H0z" fill="#B3C39A" stroke="#103948" stroke-width="4"/><path d="M310 600c26-60 100-96 102-194h30c4 108-58 140-64 194z" fill="#EFE4CC"/><path d="M560 462h150M556 482h158" ' +
          S +
          '/><rect x="556" y="456" width="158" height="14" rx="4" fill="#B8936A" ' +
          S +
          '/><rect x="552" y="478" width="166" height="12" rx="4" fill="#B8936A" ' +
          S +
          '/><path d="M572 490v30M698 490v30" ' +
          S +
          "/>" +
          tuft(250, 468) +
          tuft(470, 566) +
          tuft(770, 470) +
          tuft(120, 560)
        );
      }),
      (B.pond = function (t) {
        var c = A.times[t],
          r = "",
          sc = "";
        [
          [408, 490],
          [426, 482],
          [778, 470],
          [760, 462],
        ].forEach(function (p, i) {
          r +=
            '<path d="M' +
            p[0] +
            " " +
            p[1] +
            "v-" +
            (60 + (i % 2) * 14) +
            '" stroke="#6F8F55" stroke-width="5" stroke-linecap="round"/><rect x="' +
            (p[0] - 7) +
            '" y="' +
            (p[1] - 60 - (i % 2) * 14 - 24) +
            '" width="14" height="30" rx="7" fill="#8a6a3d" stroke="#103948" stroke-width="3"/>';
        });
        for (var k = 0; k < 6; k++) sc += "a15 15 0 0 1-30 0";
        var wil =
          '<rect x="96" y="210" width="20" height="200" rx="4" fill="#8a6a3d" ' +
          S +
          '/><path d="M196 330C196 220 160 160 106 160S16 220 16 330a15 15 0 0 0 30 0a15 15 0 0 0 30 0a15 15 0 0 0 30 0a15 15 0 0 0 30 0a15 15 0 0 0 30 0a15 15 0 0 0 30 0z" fill="#9BB27E" ' +
          S +
          '/><path d="M60 230v80M106 200v100M152 230v80" stroke="#7C9A60" stroke-width="4" stroke-linecap="round"/>';
        return (
          sky(t) +
          '<path d="M0 318C150 290 300 300 420 296s270-24 380 2V600H0z" fill="' +
          c.hill +
          '"/>' +
          wil +
          tree(720, 240, 72, 200) +
          '<path d="M0 400c160-16 320-12 460-6s240-4 340-10V600H0z" fill="#B3C39A" stroke="#103948" stroke-width="4"/><path d="M560 398c-6 30 10 50 30 62h44c-20-14-34-34-30-63z" fill="#A9CCDD"/><path d="M560 398c-6 30 10 50 30 62M634 460c-20-14-34-34-30-63" fill="none" stroke="#103948" stroke-width="4" stroke-linecap="round"/><path d="M420 512c0-40 90-60 200-60s180 22 180 22v126H470c-30-30-50-50-50-88z" fill="#A9CCDD" stroke="#103948" stroke-width="4"/><g fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round"><path d="M500 500q30-7 60 0"/><path d="M640 540q30-7 60 0"/><path d="M590 420q12-3 22 0"/></g><g fill="#7C9A60" stroke="#103948" stroke-width="3"><path d="M560 566a24 10 0 1 0 1 0"/><path d="M720 510a20 9 0 1 0 1 0"/></g><g fill="#B9B3A6" stroke="#103948" stroke-width="3"><ellipse cx="300" cy="560" rx="18" ry="8"/><ellipse cx="340" cy="580" rx="15" ry="7"/></g>' +
          r +
          tuft(260, 440) +
          tuft(180, 560) +
          tuft(520, 420)
        );
      }),
      (A.scene = function (t, p) {
        return (B[p] || B.garden)(t);
      }));
  })(window.NONO_ART),
  (function (A) {
    var N = "#103948",
      S =
        'stroke="#103948" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"',
      T =
        'stroke="#103948" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" fill="none"',
      eye = function (x, y) {
        return (
          '<circle cx="' +
          x +
          '" cy="' +
          y +
          '" r="3.4" fill="' +
          N +
          '"/><circle cx="' +
          (x + 1) +
          '" cy="' +
          (y - 1) +
          '" r="1.1" fill="#fff"/>'
        );
      };
    function petals(cx, cy, n, len, w, fill) {
      for (var s = "", i = 0; i < n; i++)
        s +=
          '<ellipse cx="' +
          cx +
          '" cy="' +
          (cy - len) +
          '" rx="' +
          w +
          '" ry="' +
          len * 0.62 +
          '" transform="rotate(' +
          (i * 360) / n +
          " " +
          cx +
          " " +
          cy +
          ')" fill="' +
          fill +
          '" stroke="#103948" stroke-width="3"/>';
      return s;
    }
    var add = {
      caterpillar: {
        g: "minibeasts",
        name: "Caterpillar",
        short: "Caterpillar",
        find: "Look under leaves for nibbled holes.",
        s: 0.75,
        zone: "ground",
        svg:
          '<path d="M24 70v8M38 70v8M52 70v8M66 70v8" ' +
          T +
          '/><circle cx="24" cy="62" r="11" fill="#9DBB6A" ' +
          S +
          '/><circle cx="38" cy="58" r="12" fill="#9DBB6A" ' +
          S +
          '/><circle cx="52" cy="58" r="12" fill="#9DBB6A" ' +
          S +
          '/><circle cx="66" cy="60" r="12" fill="#9DBB6A" ' +
          S +
          '/><circle cx="80" cy="50" r="13" fill="#9DBB6A" ' +
          S +
          '/><path d="M78 37l-3-9M86 38l4-8" ' +
          T +
          "/>" +
          eye(84, 48),
      },
      beetle: {
        g: "minibeasts",
        name: "Ground beetle",
        short: "Beetle",
        find: "Shiny and quick. Look under logs and stones.",
        s: 0.75,
        zone: "ground",
        svg:
          '<path d="M30 46 16 38M28 60H12M30 74l-14 8M70 46l14-8M72 60h16M70 74l14 8M44 22l-6-10M56 22l6-10" ' +
          T +
          '/><circle cx="50" cy="28" r="10" fill="' +
          N +
          '"/><ellipse cx="50" cy="60" rx="22" ry="28" fill="#3E6B5C" ' +
          S +
          '/><path d="M50 34v54" ' +
          S +
          "/>",
      },
      dragonfly: {
        g: "minibeasts",
        name: "Dragonfly",
        short: "Dragonfly",
        find: "Zooms over ponds on sunny days.",
        s: 0.85,
        zone: "sky",
        svg:
          '<ellipse cx="30" cy="34" rx="22" ry="9" transform="rotate(-12 30 34)" fill="#DCEBF2" ' +
          S +
          '/><ellipse cx="70" cy="34" rx="22" ry="9" transform="rotate(12 70 34)" fill="#DCEBF2" ' +
          S +
          '/><ellipse cx="32" cy="52" rx="19" ry="8" transform="rotate(10 32 52)" fill="#DCEBF2" ' +
          S +
          '/><ellipse cx="68" cy="52" rx="19" ry="8" transform="rotate(-10 68 52)" fill="#DCEBF2" ' +
          S +
          '/><path d="M50 40v50" stroke="' +
          N +
          '" stroke-width="11" stroke-linecap="round"/><path d="M50 40v48" stroke="#4A8FB0" stroke-width="5" stroke-linecap="round"/><circle cx="50" cy="28" r="10" fill="#4A8FB0" ' +
          S +
          "/>",
      },
      moth: {
        g: "minibeasts",
        name: "Moth",
        short: "Moth",
        find: "Comes to lights at night. Fluffy and brown.",
        s: 0.75,
        zone: "sky",
        svg:
          '<path d="M46 30l-8-14M54 30l8-14" ' +
          T +
          '/><path d="M48 40C34 24 10 26 12 46c1 14 18 20 36 12z" fill="#BFA98A" ' +
          S +
          '/><path d="M52 40c14-16 38-14 36 6-1 14-18 20-36 12z" fill="#BFA98A" ' +
          S +
          '/><path d="M48 60C38 66 30 80 38 84s10-10 10-20zM52 60c10 6 18 20 10 24s-10-10-10-20z" fill="#A08C6C" ' +
          S +
          '/><ellipse cx="50" cy="56" rx="6" ry="24" fill="#8a6a3d" ' +
          S +
          "/>",
      },
      grasshopper: {
        g: "minibeasts",
        name: "Grasshopper",
        short: "Grasshopper",
        find: "Listen for chirps in long grass in summer.",
        s: 0.8,
        zone: "ground",
        svg:
          '<path d="M36 64l-6 16M48 64l-2 16M76 46l8-20" ' +
          T +
          '/><path d="M10 60c0-10 12-16 28-16h30c10 0 16 6 16 12s-6 10-16 10H22c-8 0-12-2-12-6z" fill="#9DBB6A" ' +
          S +
          '/><path d="M30 54 52 26l14 32z" fill="#7C9A60" ' +
          S +
          '/><path d="M52 26 60 84" ' +
          S +
          ' fill="none"/>' +
          eye(76, 52),
      },
      mallard: {
        g: "birds",
        name: "Mallard duck",
        short: "Duck",
        find: "Dads have a shiny green head. Mums are brown.",
        s: 1,
        zone: "pond",
        svg: '<path d="M12 60c0 18 14 26 36 26s34-10 36-28c-12 6-26 4-38 0-12-6-26-6-34 2z" fill="#BFA98A" stroke="#103948" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"/><path d="M56 62c0-14 4-24 4-32" fill="none" stroke="#103948" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"/><circle cx="64" cy="30" r="14" fill="#3E7D5A" stroke="#103948" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"/><path d="M58 44h12" stroke="#fff" stroke-width="4"/><path d="M76 30h16c0 6-6 8-16 6z" fill="#E3A23B" stroke="#103948" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"/><circle cx="66" cy="26" r="3.4" fill="#103948"/><circle cx="67" cy="25" r="1.1" fill="#fff"/>',
      },
      crow: {
        g: "birds",
        name: "Carrion crow",
        short: "Crow",
        find: "All black and loud. Listen for a caw.",
        s: 1,
        zone: "ground",
        svg: '<path d="M44 76l-3 14M56 76l2 14" stroke="#103948" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M24 58 6 64l18 8z" fill="#103948"/><ellipse cx="46" cy="60" rx="27" ry="19" fill="#103948"/><circle cx="68" cy="40" r="15" fill="#103948"/><path d="M80 34l16 8-16 4z" fill="#556D78" stroke="#103948" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"/><circle cx="71" cy="36" r="3.2" fill="#fff"/>',
      },
      swan: {
        g: "birds",
        name: "Mute swan",
        short: "Swan",
        find: "Big and white, with an orange beak. Give it space.",
        s: 1.1,
        zone: "pond",
        svg:
          '<path d="M10 66c4 14 18 20 40 20s34-8 38-22c-14 2-24-4-30-12-12 10-34 14-48 14z" fill="#fff" ' +
          S +
          '/><path d="M60 58C48 40 50 18 66 16c8 0 12 6 10 12" fill="none" stroke="' +
          N +
          '" stroke-width="13" stroke-linecap="round"/><path d="M60 58C48 40 50 18 66 16c8 0 12 6 10 12" fill="none" stroke="#fff" stroke-width="6" stroke-linecap="round"/><path d="M74 22l14 8-12 4z" fill="#E07A3E" ' +
          S +
          '/><circle cx="68" cy="22" r="2.6" fill="' +
          N +
          '"/>',
      },
      owl: {
        g: "birds",
        name: "Tawny owl",
        short: "Owl",
        find: "Listen at night for twit and twoo.",
        s: 1,
        zone: "tree",
        svg:
          '<path d="M26 30 22 14l14 10M74 30l4-16-14 10" fill="#A0764A" ' +
          S +
          '/><ellipse cx="50" cy="56" rx="28" ry="34" fill="#A0764A" ' +
          S +
          '/><circle cx="38" cy="42" r="11" fill="#F1E3C6" ' +
          S +
          '/><circle cx="62" cy="42" r="11" fill="#F1E3C6" ' +
          S +
          '/><circle cx="38" cy="42" r="4.5" fill="' +
          N +
          '"/><circle cx="62" cy="42" r="4.5" fill="' +
          N +
          '"/><path d="M46 52l4 7 4-7z" fill="#E3A23B" ' +
          S +
          '/><path d="M40 70l4 4 4-4M52 70l4 4 4-4M46 80l4 4 4-4" ' +
          T +
          "/>",
      },
      wren: {
        g: "birds",
        name: "Wren",
        short: "Wren",
        find: "Tiny brown bird with its tail sticking up. Very loud song.",
        s: 0.7,
        zone: "tree",
        svg:
          '<path d="M44 78l-3 12M56 78l2 12" ' +
          T +
          '/><path d="M30 56 18 24l20 26z" fill="#8a6a3d" ' +
          S +
          '/><circle cx="50" cy="62" r="22" fill="#A0764A" ' +
          S +
          '/><path d="M70 54l14 3-14 5z" fill="#E3A23B" ' +
          S +
          '/><path d="M50 44c6-3 14-2 18 2" ' +
          T +
          "/>" +
          eye(62, 52),
      },
      pine: {
        g: "trees",
        name: "Scots pine",
        short: "Pine tree",
        find: "Green needles all year. Smell them.",
        s: 1.3,
        zone: "any",
        svg:
          '<rect x="44" y="76" width="12" height="16" rx="2" fill="#8a6a3d" ' +
          S +
          '/><path d="M50 8 26 40h12L20 62h14L14 80h72L66 62h14L62 40h12z" fill="#4F7A52" ' +
          S +
          "/>",
      },
      maple: {
        g: "trees",
        name: "Field maple leaf",
        short: "Maple leaf",
        find: "A leaf with five round points. Yellow in autumn.",
        s: 0.85,
        zone: "any",
        svg:
          '<path d="M50 90V62" ' +
          S +
          ' fill="none"/><path d="M50 12l10 18 14-6-4 18 18 4-14 14 6 10-22-4-8 8-8-8-22 4 6-10-14-14 18-4-4-18 14 6z" fill="#E3A23B" ' +
          S +
          '/><path d="M50 30v32M50 62 32 48M50 62l18-14" ' +
          T +
          "/>",
      },
      hazel: {
        g: "trees",
        name: "Hazelnut",
        short: "Hazelnut",
        find: "Squirrels love them. Look for nibbled shells.",
        s: 0.7,
        zone: "ground",
        svg:
          '<path d="M22 46c4-18 20-26 28-26s24 8 28 26c-10-6-18-4-28 2-10-6-18-8-28-2z" fill="#9DBB6A" ' +
          S +
          '/><circle cx="50" cy="62" r="24" fill="#B07A44" ' +
          S +
          '/><path d="M34 48h32" ' +
          T +
          '/><path d="M40 64c2 6 6 9 10 10" stroke="#fff" stroke-width="4" stroke-linecap="round" fill="none"/>',
      },
      tadpole: {
        g: "amphibians",
        name: "Tadpole",
        short: "Tadpole",
        find: "Wiggly baby frogs in ponds in spring.",
        s: 0.6,
        zone: "pond",
        svg:
          '<path d="M46 54c14-4 24 10 46-2-10 16-30 14-46 10" fill="#556D78" ' +
          S +
          '/><circle cx="34" cy="52" r="20" fill="' +
          N +
          '"/><circle cx="28" cy="46" r="3.4" fill="#fff"/>',
      },
      frogspawn: {
        g: "amphibians",
        name: "Frogspawn",
        short: "Frogspawn",
        find: "Jelly blobs with black dots in ponds in spring.",
        s: 0.8,
        zone: "pond",
        svg: (function () {
          var s = "",
            c = [
              [30, 40],
              [50, 34],
              [70, 42],
              [22, 60],
              [42, 56],
              [62, 60],
              [80, 62],
              [34, 76],
              [54, 78],
              [72, 80],
            ];
          return (
            c.forEach(function (p) {
              s +=
                '<circle cx="' +
                p[0] +
                '" cy="' +
                p[1] +
                '" r="11" fill="#DCEBF2" ' +
                S +
                "/>";
            }),
            c.forEach(function (p) {
              s +=
                '<circle cx="' +
                p[0] +
                '" cy="' +
                p[1] +
                '" r="3.6" fill="' +
                N +
                '"/>';
            }),
            s
          );
        })(),
      },
      badger: {
        g: "mammals",
        name: "Badger",
        short: "Badger",
        find: "Black and white stripy face. Out at night.",
        s: 1.1,
        zone: "ground",
        svg:
          '<path d="M24 74v14M38 76v12M56 76v12M68 74v14" ' +
          S +
          ' fill="none"/><ellipse cx="44" cy="62" rx="34" ry="18" fill="#A7B0B6" ' +
          S +
          '/><path d="M62 46c8-8 26-6 32 10-4 8-14 10-24 8-8-2-12-10-8-18z" fill="#fff" ' +
          S +
          '/><path d="M66 46c8-2 18 0 26 8-2 2-4 3-6 3-6-4-12-6-20-5z" fill="' +
          N +
          '"/><path d="M64 52c2 6 6 10 14 12" stroke="' +
          N +
          '" stroke-width="5" fill="none"/><path d="M64 44l2-6 6 4" fill="' +
          N +
          '" ' +
          S +
          '/><circle cx="94" cy="57" r="3.4" fill="' +
          N +
          '"/>',
      },
      deer: {
        g: "mammals",
        name: "Roe deer",
        short: "Deer",
        find: "Shy. Look at the edge of woods at dawn.",
        s: 1.25,
        zone: "ground",
        svg:
          '<path d="M32 66v24M42 68v22M62 68v22M72 66v24" ' +
          S +
          ' fill="none"/><ellipse cx="52" cy="58" rx="26" ry="14" fill="#B07A44" ' +
          S +
          '/><path d="M70 50 78 28" stroke="' +
          N +
          '" stroke-width="14" stroke-linecap="round"/><path d="M70 50 78 28" stroke="#B07A44" stroke-width="7" stroke-linecap="round"/><ellipse cx="82" cy="26" rx="12" ry="8" transform="rotate(20 82 26)" fill="#B07A44" ' +
          S +
          '/><path d="M76 18 72 6M72 10l-6-2M84 16l2-12M85 9l6-3" ' +
          T +
          "/>" +
          eye(84, 24),
      },
      mouse: {
        g: "mammals",
        name: "Wood mouse",
        short: "Mouse",
        find: "Big ears and a long tail. Very shy.",
        s: 0.65,
        zone: "ground",
        svg:
          '<path d="M20 70C6 70 6 54 16 52" ' +
          T +
          '/><path d="M20 72c0-18 14-28 32-28 14 0 24 8 34 24-6 4-14 4-22 4z" fill="#B07A44" ' +
          S +
          '/><circle cx="58" cy="42" r="11" fill="#D99A8A" ' +
          S +
          '/><circle cx="86" cy="68" r="3" fill="' +
          N +
          '"/>' +
          eye(72, 58),
      },
      bat: {
        g: "mammals",
        name: "Pipistrelle bat",
        short: "Bat",
        find: "Flits about at dusk in summer.",
        s: 0.85,
        zone: "sky",
        svg:
          '<path d="M50 40c-8-6-24-10-42-4 6 4 8 10 6 16 6-4 12-2 16 4 4-6 12-6 20-2zM50 40c8-6 24-10 42-4-6 4-8 10-6 16-6-4-12-2-16 4-4-6-12-6-20-2z" fill="#6E5A4A" ' +
          S +
          '/><ellipse cx="50" cy="50" rx="10" ry="14" fill="#6E5A4A" ' +
          S +
          '/><path d="M43 38l-1-10 7 6M57 38l1-10-7 6" fill="#6E5A4A" ' +
          S +
          '/><circle cx="46" cy="44" r="2.4" fill="#fff"/><circle cx="54" cy="44" r="2.4" fill="#fff"/>',
      },
      buttercup: {
        g: "fungi",
        name: "Buttercup",
        short: "Buttercup",
        find: "Shiny yellow. Hold it under a chin.",
        s: 0.65,
        zone: "ground",
        svg:
          '<path d="M50 92V56" ' +
          S +
          ' fill="none"/>' +
          petals(50, 40, 5, 16, 12, "#F2C230") +
          '<circle cx="50" cy="40" r="7" fill="#E3A23B" stroke="#103948" stroke-width="3"/>',
      },
      bluebell: {
        g: "fungi",
        name: "Bluebell",
        short: "Bluebell",
        find: "Carpets of blue in woods in spring. Stay on the path.",
        s: 0.8,
        zone: "ground",
        svg:
          '<path d="M30 92c4-40 20-70 50-78" ' +
          S +
          ' fill="none"/><path d="M40 92c-4-20-2-34 2-44" ' +
          T +
          "/>" +
          [
            [46, 34],
            [60, 26],
            [36, 50],
            [32, 68],
          ]
            .map(function (p) {
              return (
                '<path d="M' +
                (p[0] - 9) +
                " " +
                p[1] +
                'c0 10 2 16 9 18 7-2 9-8 9-18-6-4-12-4-18 0z" fill="#6E79C9" ' +
                S +
                "/>"
              );
            })
            .join(""),
      },
      clover: {
        g: "fungi",
        name: "Clover",
        short: "Clover",
        find: "Count the leaves. Can you find four?",
        s: 0.6,
        zone: "ground",
        svg:
          '<path d="M50 52 56 92" ' +
          S +
          ' fill="none"/><circle cx="36" cy="40" r="15" fill="#7C9A60" ' +
          S +
          '/><circle cx="64" cy="40" r="15" fill="#7C9A60" ' +
          S +
          '/><circle cx="50" cy="22" r="15" fill="#7C9A60" ' +
          S +
          '/><circle cx="50" cy="38" r="5" fill="#fff"/>',
      },
      blackberry: {
        g: "fungi",
        name: "Blackberry",
        short: "Blackberry",
        find: "Ripe in late summer. Ask an adult before picking.",
        s: 0.65,
        zone: "any",
        svg:
          '<path d="M36 22l14 8 14-8M50 30V14" ' +
          S +
          ' fill="#7C9A60"/>' +
          [
            [42, 42],
            [58, 42],
            [34, 58],
            [50, 56],
            [66, 58],
            [42, 72],
            [58, 72],
            [50, 86],
          ]
            .map(function (p) {
              return (
                '<circle cx="' +
                p[0] +
                '" cy="' +
                p[1] +
                '" r="10" fill="#4B2E5C" ' +
                S +
                "/>"
              );
            })
            .join("") +
          '<circle cx="46" cy="40" r="2.4" fill="#fff"/>',
      },
      toadstool: {
        g: "fungi",
        name: "Brown mushroom",
        short: "Mushroom",
        find: "Pops up in damp grass in autumn. Look, never touch.",
        s: 0.75,
        zone: "ground",
        svg:
          '<path d="M40 52h20l4 36H36z" fill="#F1E3C6" ' +
          S +
          '/><path d="M10 54c0-24 18-40 40-40s40 16 40 40z" fill="#A0764A" ' +
          S +
          '/><path d="M30 30c4-4 10-7 16-8" stroke="#fff" stroke-width="4" stroke-linecap="round" fill="none"/>',
      },
      feather: {
        g: "finds",
        name: "Feather",
        short: "Feather",
        find: "Look under trees. Which bird dropped it?",
        s: 0.75,
        zone: "ground",
        svg:
          '<path d="M20 86C30 50 54 18 86 12c4 30-22 58-58 66z" fill="#DCEBF2" ' +
          S +
          '/><path d="M16 92 80 18M40 66l-10-6M52 52l-12-8M64 38l-10-8" ' +
          T +
          "/>",
      },
      pinecone: {
        g: "finds",
        name: "Pine cone",
        short: "Pine cone",
        find: "Shut when wet, open when dry.",
        s: 0.7,
        zone: "ground",
        svg:
          '<path d="M50 6v10" ' +
          S +
          '/><path d="M50 14c18 0 26 22 22 44-4 20-14 32-22 32s-18-12-22-32c-4-22 4-44 22-44z" fill="#A0764A" ' +
          S +
          '/><path d="M32 36l18 10 18-10M30 54l20 12 20-12M36 72l14 10 14-10" ' +
          T +
          "/>",
      },
      stick: {
        g: "finds",
        name: "Stick",
        short: "Stick",
        find: "Find a stick taller than you. Or the smallest one.",
        s: 0.9,
        zone: "ground",
        svg:
          '<path d="M10 80 90 26" stroke="' +
          N +
          '" stroke-width="13" stroke-linecap="round"/><path d="M10 80 90 26" stroke="#8a6a3d" stroke-width="6" stroke-linecap="round"/><path d="M52 52 60 30" stroke="' +
          N +
          '" stroke-width="10" stroke-linecap="round"/><path d="M52 52 60 30" stroke="#8a6a3d" stroke-width="4" stroke-linecap="round"/><path d="M60 30c-6-6-4-14 4-16 4 8 2 14-4 16z" fill="#7C9A60" ' +
          S +
          "/>",
      },
      pebble: {
        g: "finds",
        name: "Smooth pebble",
        short: "Pebble",
        find: "Find the smoothest stone you can.",
        s: 0.6,
        zone: "ground",
        svg:
          '<path d="M14 64c0-20 18-34 40-34s34 14 34 30-16 26-38 26S14 78 14 64z" fill="#A7B0B6" ' +
          S +
          '/><path d="M34 48c6-4 14-6 22-6" stroke="#fff" stroke-width="5" stroke-linecap="round" fill="none"/><circle cx="66" cy="66" r="4" fill="#556D78"/>',
      },
      puddle: {
        g: "finds",
        name: "Puddle",
        short: "Puddle",
        find: "Jump in with wellies on. How big a splash?",
        s: 1,
        zone: "ground",
        svg:
          '<path d="M12 70c0-10 12-12 20-16 8-6 20-6 30-2 10 2 26 2 26 14s-16 18-38 18S12 80 12 70z" fill="#A9CCDD" ' +
          S +
          '/><path d="M34 66q12-6 24 0" stroke="#fff" stroke-width="4" stroke-linecap="round" fill="none"/><path d="M30 40l-4-10M50 34V22M70 40l4-10" ' +
          T +
          "/>",
      },
      nest: {
        g: "finds",
        name: "Empty bird\u2019s nest",
        short: "Nest",
        find: "Look, but leave it where it is.",
        s: 0.85,
        zone: "tree",
        svg:
          '<ellipse cx="38" cy="50" rx="8" ry="10" fill="#A9CCDD" ' +
          S +
          '/><ellipse cx="54" cy="48" rx="8" ry="10" fill="#A9CCDD" ' +
          S +
          '/><ellipse cx="68" cy="52" rx="7" ry="9" fill="#A9CCDD" ' +
          S +
          '/><path d="M10 52h80c0 20-18 34-40 34S10 72 10 52z" fill="#B07A44" ' +
          S +
          '/><path d="M18 62h64M26 74h48M14 56l20 8M86 56l-20 8" ' +
          T +
          "/>",
      },
    };
    for (var k in add) A.items[k] = add[k];
    A.groups = [
      ["minibeasts", "Minibeasts", "Minibeasts", "ladybird"],
      ["snails", "Snails and slugs", "Snails", "snail"],
      ["birds", "Birds", "Birds", "robin"],
      ["trees", "Trees and leaves", "Trees", "oak"],
      ["amphibians", "Frogs, toads and newts", "Frogs", "frog"],
      ["mammals", "Mammals", "Mammals", "hedgehog"],
      ["fungi", "Fungi and flowers", "Flowers", "daisy"],
      ["finds", "Finds", "Finds", "feather"],
    ];
  })(window.NONO_ART),
  (function (A) {
    var N = "#103948",
      S =
        'stroke="#103948" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"',
      T =
        'stroke="#103948" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" fill="none"',
      it = A.items;
    ((it.snowdrop = {
      g: "fungi",
      name: "Snowdrop",
      short: "Snowdrop",
      find: "Little white flowers that nod, even in the snow.",
      s: 0.65,
      zone: "ground",
      season: ["winter"],
      svg:
        '<path d="M50 92V40c0-10 6-16 14-18M40 92c0-14-4-24-12-30M60 92c0-14 6-22 14-26" ' +
        T +
        '/><path d="M52 22c-14 2-20 16-16 32 4-2 8-8 9-14 2 8 7 13 12 14 3-16-2-30-5-32z" fill="#fff" ' +
        S +
        '/><path d="M47 40c1 4 3 6 5 7" stroke="#7C9A60" stroke-width="3" stroke-linecap="round" fill="none"/>',
    }),
      (it.blossom = {
        g: "trees",
        name: "Blossom",
        short: "Blossom",
        find: "Pink and white flowers on trees in spring.",
        s: 0.75,
        zone: "tree",
        season: ["spring"],
        svg:
          '<path d="M10 84C30 66 52 56 90 48M44 62 36 38" stroke="#8a6a3d" stroke-width="8" stroke-linecap="round" fill="none"/><path d="M10 84C30 66 52 56 90 48M44 62 36 38" ' +
          T +
          "/>" +
          [
            [70, 40],
            [34, 30],
            [56, 64],
          ]
            .map(function (p) {
              for (var s = "", i = 0; i < 5; i++)
                s +=
                  '<circle cx="' +
                  p[0] +
                  '" cy="' +
                  (p[1] - 8) +
                  '" r="7" transform="rotate(' +
                  i * 72 +
                  " " +
                  p[0] +
                  " " +
                  p[1] +
                  ')" fill="#F5C6D1" stroke="#103948" stroke-width="3"/>';
              return (
                s +
                '<circle cx="' +
                p[0] +
                '" cy="' +
                p[1] +
                '" r="4" fill="#E3A23B"/>'
              );
            })
            .join(""),
      }),
      (it.frost = {
        g: "finds",
        name: "Frosty leaf",
        short: "Frost",
        find: "Look for white sparkly frost on cold mornings.",
        s: 0.7,
        zone: "ground",
        season: ["winter"],
        svg:
          '<path d="M50 90V60" ' +
          T +
          '/><path d="M50 62C24 62 14 40 22 14c22 2 40 18 28 48zM50 62c26 0 36-22 28-48-22 2-40 18-28 48z" fill="#DCEBF2" ' +
          S +
          '/><path d="M50 62 30 26M50 62l20-36" ' +
          T +
          '/><path d="M28 50l4-4M36 18l4 4M64 18l-4 4M72 50l-4-4" stroke="#fff" stroke-width="4" stroke-linecap="round"/>',
      }),
      (A.seasons = {
        spring: {
          label: "Spring",
          crown: ["#8DBA6A", "#9FC77A"],
          hill: "#D7E8C6",
          ground: "#BFD89A",
          sky: "#EEF5F1",
          overlay: "blossom",
          items: [
            "frogspawn",
            "tadpole",
            "bluebell",
            "daisy",
            "dandelion",
            "blossom",
            "bumblebee",
            "blackbird",
            "bluetit",
            "rabbit",
            "newt",
            "buttercup",
            "worm",
          ],
        },
        summer: {
          label: "Summer",
          crown: ["#5E8B4A", "#6F9A56"],
          hill: "#CFE0B8",
          ground: "#A9C27E",
          sky: "#DCEDF5",
          overlay: "sun",
          items: [
            "butterfly",
            "bumblebee",
            "dragonfly",
            "grasshopper",
            "buttercup",
            "clover",
            "daisy",
            "swan",
            "mallard",
            "frog",
            "bat",
            "ant",
            "ladybird",
          ],
        },
        autumn: {
          label: "Autumn",
          crown: ["#D98A3D", "#C9643A", "#E3A23B"],
          hill: "#E6DCC0",
          ground: "#C9C08A",
          sky: "#F6EBDD",
          overlay: "leaves",
          items: [
            "conker",
            "oak",
            "sycamore",
            "maple",
            "hazel",
            "toadstool",
            "flyagaric",
            "squirrel",
            "hedgehog",
            "pinecone",
            "spider",
            "blackberry",
            "woodpigeon",
            "puddle",
          ],
        },
        winter: {
          label: "Winter",
          crown: ["#E9EFF1", "#DDE6EA"],
          hill: "#E6ECEF",
          ground: "#F1F5F6",
          sky: "#DCE5EC",
          overlay: "snow",
          items: [
            "robin",
            "holly",
            "snowdrop",
            "frost",
            "pine",
            "fox",
            "wren",
            "bluetit",
            "feather",
            "badger",
            "stick",
            "pebble",
            "owl",
          ],
        },
      }));
  })(window.NONO_ART),
  (function (A) {
    if (!A || !A.seasons) return;
    var M = [
      "winter",
      "winter",
      "spring",
      "spring",
      "spring",
      "summer",
      "summer",
      "summer",
      "autumn",
      "autumn",
      "autumn",
      "winter",
    ];
    /* v8: season is set by date in the patch below */
    function rnd(i) {
      return Math.abs((Math.sin(i * 99.13) * 43758.5) % 1);
    }
    var CROWN = /#A7BA90|#6F8F55|#8FA874|#7C9A60/i,
      base = A.scene;
    A.scene = function (t, p) {
      var se = A.seasons[A.seasonKey],
        s = base(t, p);
      if (!se) return s;
      var crowns = [];
      ((s = s.replace(
        /<circle cx="([\d.]+)" cy="([\d.]+)" r="([\d.]+)" fill="(#[0-9A-Fa-f]{6})"/g,
        function (m, x2, y2, r, f) {
          return !CROWN.test(f) || +r < 18
            ? m
            : (crowns.push([+x2, +y2, +r]),
              '<circle cx="' +
                x2 +
                '" cy="' +
                y2 +
                '" r="' +
                r +
                '" fill="' +
                se.crown[crowns.length % se.crown.length] +
                '"');
        },
      )),
        (s = s
          .replace(/#DDE5D3|#D3DCC8/gi, se.hill)
          .replace(/#A9B68A|#B3C39A|#9BB27E/gi, se.ground)
          .replace(/#E8F0F3/gi, se.sky)
          .replace(/#A7BA90|#6F8F55|#8FA874/gi, se.crown[0])));
      var ov = "";
      if (
        (se.overlay === "blossom" &&
          crowns.forEach(function (c, j) {
            for (var i2 = 0; i2 < 5; i2++) {
              var a = i2 * 2.4 + j,
                r = c[2] * 0.55;
              ov +=
                '<circle cx="' +
                (c[0] + Math.cos(a) * r).toFixed(1) +
                '" cy="' +
                (c[1] + Math.sin(a) * r).toFixed(1) +
                '" r="6" fill="#F5C6D1" stroke="#103948" stroke-width="2"/>';
            }
          }),
        se.overlay === "leaves")
      )
        for (var i = 0; i < 14; i++) {
          var x = (40 + rnd(i + 1) * 720).toFixed(1),
            y = (120 + rnd(i + 7) * 420).toFixed(1);
          ov +=
            '<path d="M' +
            x +
            " " +
            y +
            'q8-10 16 0q-8 10-16 0z" transform="rotate(' +
            i * 37 +
            " " +
            x +
            " " +
            y +
            ')" fill="' +
            ["#D98A3D", "#C9643A", "#E3A23B"][i % 3] +
            '" stroke="#103948" stroke-width="2"/>';
        }
      if (se.overlay === "snow") {
        crowns.forEach(function (c) {
          ov +=
            '<path d="M' +
            (c[0] - c[2] * 0.8) +
            " " +
            (c[1] - c[2] * 0.35) +
            "a" +
            c[2] * 0.8 +
            " " +
            c[2] * 0.6 +
            " 0 0 1 " +
            c[2] * 1.6 +
            ' 0z" fill="#fff"/>';
        });
        for (var k = 0; k < 40; k++)
          ov +=
            '<circle cx="' +
            (rnd(k + 3) * 800).toFixed(1) +
            '" cy="' +
            (rnd(k + 11) * 560).toFixed(1) +
            '" r="' +
            (3 + (k % 3)) +
            '" fill="#fff" stroke="#B9C9D1" stroke-width="1"/>';
      }
      return (
        s +
        (ov ? '<g class="sg-season-ov" aria-hidden="true">' + ov + "</g>" : "")
      );
    };
  })(window.NONO_ART));
/* ---- v8 patch (2026-10-14): icon fixes, place icons, autumn items, real UK seasons by date ----
   Placeholder art in the house style (navy #103948 outline, 4px, viewBox 0 0 100 100). Every svg here is swappable:
   replace A.items[key].svg (or use the sg-overrides JSON image URLs, which still win). */
(function (A) {
  if (!A) return;
  var N = "#103948",
    S = 'stroke="#103948" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"',
    T = 'stroke="#103948" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" fill="none"',
    eye = function (x, y) { return '<circle cx="' + x + '" cy="' + y + '" r="3.4" fill="' + N + '"/><circle cx="' + (x + 1) + '" cy="' + (y - 1) + '" r="1.1" fill="#fff"/>'; },
    it = A.items;
  function set(k, o) { it[k] = Object.assign(it[k] || {}, o); }

  /* --- redraws --- */
  set("mallard", { svg:
    '<path d="M8 86h84" stroke="#A9CCDD" stroke-width="5" stroke-linecap="round"/>' +
    '<path d="M14 60 6 46l16 8z" fill="#556D78" ' + S + '/>' +
    '<path d="M12 60c0 14 14 22 36 22s34-8 36-22c-6 2-14 0-20-6H26c-8 0-14 1-14 6z" fill="#BFA98A" ' + S + '/>' +
    '<path d="M30 62c10-6 24-6 32 0-8 6-24 6-32 0z" fill="#8a6a3d" ' + S + '/>' +
    '<path d="M58 56c-3-8-2-16 3-22a13 13 0 1 1 18 8c-4 3-6 8-5 14z" fill="#3E7D5A" ' + S + '/>' +
    '<path d="M60 50h14" stroke="#fff" stroke-width="4" stroke-linecap="round"/>' +
    '<path d="M82 31l13 4-13 5z" fill="#E3A23B" ' + S + '/>' + eye(72, 30) });
  if (it.spider) set("spider", { find: "Look for its web on misty mornings. Leave the web be.",
    svg: it.spider.svg.replace('<path d="M50 50v24M41 60h18" stroke="#fff" stroke-width="4" stroke-linecap="round"/>', '') });
  set("conker", { svg: (function () {
    /* open husk: two spiky green halves split apart, the shiny conker sitting between them */
    var sp = function (pts) { return '<path d="' + pts.map(function (p) { return "M" + p[0] + " " + p[1] + "l" + p[2] + " " + p[3]; }).join("") + '" ' + S + '/>'; };
    return sp([[20, 34, -6, -6], [12, 52, -8, 0], [16, 72, -7, 5], [30, 86, -4, 7]]) + sp([[80, 34, 6, -6], [88, 52, 8, 0], [84, 72, 7, 5], [70, 86, 4, 7]]) +
      '<path d="M40 16C20 20 8 38 10 58s14 30 30 32c-10-10-14-24-12-38s6-26 12-36z" fill="#8FAF5E" ' + S + '/>' +
      '<path d="M60 16c20 4 32 22 30 42s-14 30-30 32c10-10 14-24 12-38s-6-26-12-36z" fill="#8FAF5E" ' + S + '/>' +
      '<path d="M36 26c-6 10-8 22-6 34s6 20 12 26M64 26c6 10 8 22 6 34s-6 20-12 26" stroke="#F1E3C6" stroke-width="4" stroke-linecap="round" fill="none"/>' +
      '<circle cx="50" cy="56" r="21" fill="#7A3B22" ' + S + '/><ellipse cx="50" cy="69" rx="10" ry="5" fill="#DDC9A3"/>' +
      '<path d="M40 48q5-7 12-7" stroke="#fff" stroke-width="4" stroke-linecap="round" fill="none"/>';
  })() });
  set("hazel", { svg:
    '<path d="M50 16c14 10 24 26 24 42a24 24 0 0 1-48 0c0-16 10-32 24-42z" fill="#B07A44" ' + S + '/>' +
    '<path d="M40 40c2-6 6-12 10-16" stroke="#fff" stroke-width="4" stroke-linecap="round" fill="none"/>' +
    '<path d="M20 64c4 18 16 28 30 28s26-10 30-28l-9 6-4-10-8 9-9-11-9 11-8-9-4 10z" fill="#9DBB6A" ' + S + '/>' });
  set("sycamore", { svg:
    '<path d="M45 72C30 66 14 50 11 28c15 2 31 15 37 38z" fill="#D7C27A" ' + S + '/>' +
    '<path d="M55 72c15-6 31-22 34-44-15 2-31 15-37 38z" fill="#D7C27A" ' + S + '/>' +
    '<path d="M44 68 20 36M56 68l24-32" stroke="#103948" stroke-width="2.5" stroke-linecap="round" fill="none"/>' +
    '<circle cx="43" cy="74" r="10" fill="#A0764A" ' + S + '/><circle cx="57" cy="74" r="10" fill="#A0764A" ' + S + '/>' });

  /* --- new autumn items --- */
  set("rosehip", { g: "fungi", name: "Rosehips", short: "Rosehips", find: "Shiny red hips on wild roses. Look, don\u2019t eat.", s: 0.7, zone: "any",
    svg: '<path d="M12 90C30 72 50 58 88 40" ' + T + '/><path d="M56 62 60 80" ' + T + '/>' +
      '<ellipse cx="40" cy="48" rx="12" ry="17" transform="rotate(-20 40 48)" fill="#D9472B" ' + S + '/>' +
      '<ellipse cx="66" cy="70" rx="11" ry="15" transform="rotate(10 66 70)" fill="#D9472B" ' + S + '/>' +
      '<path d="M30 33l-3-8M35 31v-8M40 32l4-7M62 55l-2-8M67 55l2-8" ' + T + '/>' +
      '<path d="M36 42q3-4 6-4" stroke="#fff" stroke-width="3.5" stroke-linecap="round" fill="none"/>' });
  set("haws", { g: "trees", name: "Hawthorn berries (haws)", short: "Haws", find: "Dark red berries in hedges. For birds, not for us.", s: 0.7, zone: "any",
    svg: '<path d="M22 20c10 4 14 14 10 24-10-2-16-12-10-24z" fill="#7C9A60" ' + S + '/><path d="M30 42l14 16" ' + T + '/>' +
      [[44, 62], [60, 56], [56, 74], [72, 70], [40, 80]].map(function (p) { return '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="9" fill="#B8322A" ' + S + '/><circle cx="' + (p[0] + 2) + '" cy="' + (p[1] - 3) + '" r="1.8" fill="' + N + '"/>'; }).join("") });
  set("web", { g: "finds", name: "Spider web", short: "Spider web", find: "Best on misty mornings, covered in dew. Don\u2019t touch.", s: 0.9, zone: "any",
    svg: (function () {
      var c = 50, s = "", rings = [12, 24, 36], i, a, pts;
      for (i = 0; i < 8; i++) { a = i / 8 * Math.PI * 2; s += "M50 50L" + (c + Math.cos(a) * 42).toFixed(1) + " " + (c + Math.sin(a) * 42).toFixed(1); }
      rings.forEach(function (r) { pts = []; for (i = 0; i <= 8; i++) { a = i / 8 * Math.PI * 2; pts.push((c + Math.cos(a) * r).toFixed(1) + " " + (c + Math.sin(a) * r).toFixed(1)); } s += "M" + pts.join("L"); });
      return '<circle cx="50" cy="50" r="44" fill="#EAF1E4"/><path d="' + s + '" stroke="#103948" stroke-width="2.8" stroke-linejoin="round" fill="none"/>' +
        '<circle cx="74" cy="40" r="3" fill="#fff" stroke="#103948" stroke-width="1.5"/><circle cx="30" cy="66" r="3" fill="#fff" stroke="#103948" stroke-width="1.5"/>';
    })() });
  set("geese", { g: "birds", name: "Geese flying in a V", short: "Geese", find: "Listen for honking. Count the geese in the V.", s: 1, zone: "sky",
    svg: [[50, 28, 1.5], [30, 48, 1.3], [70, 48, 1.3], [14, 68, 1.1], [86, 68, 1.1]].map(function (p) {
      var x = p[0], y = p[1], k = p[2];
      return '<path d="M' + (x - 12 * k) + " " + (y + 2 * k) + "q" + 6 * k + " " + -8 * k + " " + 12 * k + " " + -1 * k + "q" + 6 * k + " " + -7 * k + " " + 12 * k + " " + 1 * k + '" stroke="#103948" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" fill="none"/>';
    }).join("") });
  set("leaves", { g: "finds", name: "Fallen leaves", short: "Fallen leaves", find: "Crunch through them. Find a red, an orange and a yellow one.", s: 0.85, zone: "ground",
    svg: [[34, 60, -30, "#C9643A"], [64, 62, 25, "#E3A23B"], [50, 44, 0, "#D98A3D"]].map(function (l) {
      return '<g transform="rotate(' + l[2] + " " + l[0] + " " + l[1] + ')"><path d="M' + l[0] + " " + (l[1] - 26) + "c14 8 18 24 0 44-18-20-14-36 0-44z" + '" fill="' + l[3] + '" ' + S + '/><path d="M' + l[0] + " " + (l[1] - 18) + "v40" + '" ' + T + '/></g>';
    }).join("") });

  set("snowdrop", { svg: '<path d="M44 92V40c0-12 8-20 20-20M36 92c-2-14-8-22-16-26M52 92c2-12 8-20 16-22" ' + T + '/>' +
    '<path d="M64 24c-9 4-12 16-7 28 3-2 5-6 7-10 2 4 4 8 7 10 5-12 2-24-7-28z" fill="#fff" ' + S + '/><path d="M62 26h4" stroke="#7C9A60" stroke-width="4" stroke-linecap="round"/>' });
  /* --- place picker icons (not checklist items) --- */
  A.placeIcons = {
    woods: it.pine ? it.pine.svg : "",
    garden: '<path d="M10 52h80M10 74h80" ' + S + '/>' + [14, 34, 54, 74].map(function (x) { return '<path d="M' + x + " 88V30l6-10 6 10v58z" + '" fill="#DDC9A3" ' + S + '/>'; }).join(""),
    park: '<path d="M18 62v24M82 62v24M24 70v16M76 70v16" ' + S + '/>' +
      '<rect x="12" y="54" width="76" height="10" rx="3" fill="#A0764A" ' + S + '/>' +
      '<rect x="12" y="26" width="76" height="10" rx="3" fill="#A0764A" ' + S + '/><rect x="12" y="40" width="76" height="9" rx="3" fill="#A0764A" ' + S + '/>' +
      '<path d="M20 36v18M80 36v18" ' + S + '/>',
    pond: it.mallard.svg
  };

  /* --- UK seasons. Each item lists the seasons you'd realistically see it (or its featured form) in the UK. --- */
  var SP = "spring", SU = "summer", AU = "autumn", WI = "winter", ALL = [SP, SU, AU, WI];
  var SEAS = {
    ladybird: [SP, SU, AU], woodlouse: ALL, worm: ALL, bumblebee: [SP, SU], butterfly: [SP, SU], spider: [SU, AU], ant: [SP, SU],
    snail: [SP, SU, AU], slug: [SP, SU, AU], robin: ALL, blackbird: ALL, bluetit: ALL, magpie: ALL, woodpigeon: ALL, sparrow: ALL,
    oak: [SP, SU, AU], sycamore: [AU], conker: [AU], birch: ALL, holly: ALL, frog: [SP, SU, AU], toad: [SP, SU], newt: [SP, SU],
    hedgehog: [SP, SU, AU], squirrel: ALL, fox: ALL, rabbit: ALL, daisy: [SP, SU], dandelion: [SP, SU], flyagaric: [AU],
    caterpillar: [SP, SU], beetle: [SP, SU, AU], dragonfly: [SU], moth: [SP, SU, AU], grasshopper: [SU], mallard: ALL, crow: ALL,
    swan: ALL, owl: ALL, wren: ALL, pine: ALL, maple: [AU], hazel: [AU], tadpole: [SP], frogspawn: [SP], badger: [SP, SU, AU],
    deer: ALL, mouse: ALL, bat: [SP, SU], buttercup: [SP, SU], bluebell: [SP], clover: [SP, SU], blackberry: [SU], toadstool: [AU],
    feather: ALL, pinecone: [AU, WI], stick: ALL, pebble: ALL, puddle: ALL, nest: [WI], blossom: [SP], snowdrop: [WI], frost: [WI],
    rosehip: [AU], haws: [AU], web: [AU], geese: [AU, WI], leaves: [AU]
  };
  Object.keys(SEAS).forEach(function (k) { if (it[k]) it[k].seasons = SEAS[k]; });
  /* restore the seasonal-only items the earlier build deleted (they're now hidden out of season instead) */
  var M = ["winter", "winter", "spring", "spring", "spring", "summer", "summer", "summer", "autumn", "autumn", "autumn", "winter"];
  var q = (location.search.match(/[?&]season=(spring|summer|autumn|winter)/) || [])[1];
  A.seasonKey = q || M[new Date().getMonth()];
  A.inSeason = function (k) { var s = it[k] && it[k].seasons; return !s || s.indexOf(A.seasonKey) > -1; };
  if (A.seasons) Object.keys(A.seasons).forEach(function (sk) {
    A.seasons[sk].items = A.seasons[sk].items.filter(function (k) { return it[k] && it[k].seasons && it[k].seasons.indexOf(sk) > -1; });
  });
  if (A.seasons && A.seasons.autumn) A.seasons.autumn.items = ["conker", "oak", "sycamore", "maple", "hazel", "toadstool", "flyagaric", "squirrel", "hedgehog", "pinecone", "web", "rosehip", "haws", "geese", "leaves", "robin"];
})(window.NONO_ART);
/* ---- v8 points: how hard is it to spot on a UK family walk? 1 = easy, 2 = look carefully, 3 = lucky, 5 = super rare.
   Night animals score higher because families rarely see them in daylight. See final-review/points.md. ---- */
(function (A) {
  if (!A) return;
  var P = {
    worm: 1, woodlouse: 1, snail: 1, slug: 1, spider: 1, web: 1, ant: 1, ladybird: 1, bumblebee: 1, butterfly: 1,
    robin: 1, blackbird: 1, woodpigeon: 1, magpie: 1, crow: 1, sparrow: 1, bluetit: 1, mallard: 1,
    oak: 1, sycamore: 1, conker: 1, birch: 1, holly: 1, pine: 1, maple: 1, leaves: 1, haws: 1, rosehip: 1, blackberry: 1, blossom: 1,
    feather: 1, pinecone: 1, stick: 1, pebble: 1, puddle: 1, frost: 1,
    daisy: 1, dandelion: 1, clover: 1, buttercup: 1, bluebell: 1, snowdrop: 1, toadstool: 1, frogspawn: 1, tadpole: 1,
    squirrel: 2, wren: 2, swan: 2, geese: 2, frog: 2, toad: 2, newt: 2, beetle: 2, moth: 2, caterpillar: 2, grasshopper: 2,
    dragonfly: 2, hazel: 2, flyagaric: 2, rabbit: 2, nest: 2,
    fox: 3, owl: 3, deer: 3, bat: 3, mouse: 3, hedgehog: 3,
    badger: 5
  };
  Object.keys(A.items).forEach(function (k) { A.items[k].pts = P[k] || 1; });
  A.badges = [["Explorer", 5], ["Tracker", 12], ["Wild Ranger", 20]];
  A.pipSVG = '<path d="M30 46h40c0 26-8 40-20 44-12-4-20-18-20-44z" fill="#E3A23B" stroke="#103948" stroke-width="7" stroke-linejoin="round"/><path d="M24 48c0-14 12-22 26-22s26 8 26 22z" fill="#8a6a3d" stroke="#103948" stroke-width="7" stroke-linejoin="round"/><path d="M50 26V12" stroke="#103948" stroke-width="7" stroke-linecap="round"/>';
  A.starSVG = '<path d="M50 6l13 28 30 3-23 20 7 30-27-16-27 16 7-30L7 37l30-3z" fill="#F2C230" stroke="#103948" stroke-width="7" stroke-linejoin="round"/>';
})(window.NONO_ART);
/* ---- v8 safety pass: nothing to forage, nothing toxic to handle. Removed: fly agaric, mushroom (toadstool),
   blackberry, haws, rosehips, holly (berries). Rewrote any "pick"/"hold" tips. ---- */
(function (A) {
  if (!A) return;
  ["flyagaric", "toadstool", "blackberry", "haws", "rosehip", "holly"].forEach(function (k) { delete A.items[k]; });
  if (A.seasons) Object.keys(A.seasons).forEach(function (sk) { A.seasons[sk].items = A.seasons[sk].items.filter(function (k) { return A.items[k]; }); });
  var it = A.items;
  if (it.woodpigeon) it.woodpigeon.short = "Pigeon";
  /* daisies and dandelions flower well into autumn in UK lawns, so the Flowers group isn't empty */
  ["daisy", "dandelion"].forEach(function (k) { it[k] && it[k].seasons && it[k].seasons.indexOf("autumn") < 0 && it[k].seasons.push("autumn"); });
  var T = {
    buttercup: "Shiny yellow petals in the grass. Look, don’t pick.",
    bluebell: "Carpets of blue in woods in spring. Stay on the path, don’t pick.",
    daisy: "White petals, yellow middle. They close at night.",
    dandelion: "A yellow flower, then a fluffy seed clock. Blow it gently.",
    conker: "Shiny conkers in spiky cases. For spotting, not eating.",
    oak: "Find an acorn in its little cup. For squirrels, not for us.",
    hazel: "Look for nut shells that squirrels have nibbled.",
    feather: "Look under trees. Which bird dropped it? Look, don’t touch.",
    clover: "Count the leaves. Can you find four?",
    caterpillar: "Look under leaves for nibbled holes. Watch, don’t touch."
  };
  Object.keys(T).forEach(function (k) { if (it[k]) it[k].find = T[k]; });
  if (A.groups) A.groups.forEach(function (g) { if (g[0] === "fungi") { g[1] = "Flowers"; g[2] = "Flowers"; } if (g[0] === "snails") { g[2] = "Snails and slugs"; } });
  A.safety = "Look, don’t touch or eat. Wash hands after your walk.";
})(window.NONO_ART);
